import React, { useEffect, useState, useCallback } from 'react';
import { message, Col, Row, Modal, Button, Form, Input, Select, DatePicker, InputNumber, Upload, Table, Spin, Space, Radio, Tag, Tooltip } from 'antd';
import { RightOutlined, UploadOutlined, InfoCircleOutlined, SoundOutlined } from '@ant-design/icons';
import { Link, useHistory, useParams } from 'react-router-dom';
import { getQualityBaseInfo, createQuality, getQualityDetail } from './api';
import { baseInfo, formatType, containerTasteList, isPureNumber, fleshColorList, fleshTasteList, handling_opinion, validateVideoBeforeUpload, useHumidityLevel } from './default';
import moment from 'moment';
import Index from './component/media';
import { deepClone, uploadBase } from '../../util/tool';
import './print.less';
import testPdf from '../../assets/qualityInspectionRequirements.pdf';

const { Option } = Select;
const { TextArea } = Input;
const formItemLayout = { labelCol: { span: 7, }, wrapperCol: { span: 16, } };
const currentTime = moment(moment(new Date()).format(formatType));

export default function WarehouseQualityReport() {
  const history = useHistory();
  const { useForm, useWatch } = Form;
  const [form] = useForm();
  const { setFieldsValue, getFieldValue, getFieldsValue } = form;
  const { order_id, quality_id, type } = useParams();
  const [info, setInfo] = useState(deepClone(baseInfo));
  const [loading, setLoading] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [currentOptions, setCurrentOptions] = useState({});
  const [qualityBaseInfo, setQualityBaseInfo] = useState({});
  const [computedSource, setComputedSource] = useState({});
  const [standardWeight, setStandardWeight] = useState(16);
  // const [ossTokenInfo, setOssTokenInfo] = useState({});
  const [canEdit, setCanEdit] = useState(true);
  const [weight_data, setWeightData] = useState([]);
  const [pdfVisible, setPdfVisible] = useState(false);
  const poor_fruit_shape_computed = useWatch('poor_fruit_shape', form);
  const fruit_house_computed = useWatch('fruit_house', form);
  const fruit_house_required = fruit_house_computed && fruit_house_computed !== '正常';
  const poor_fruit_shape_number_computed = useWatch('poor_fruit_shape_number', form);
  const poor_fruit_shape_required = poor_fruit_shape_computed && poor_fruit_shape_computed !== '正常';
  const fruit_peel_type_computed = useWatch('fruit_peel_type', form);
  const fruit_peel_type_required = fruit_peel_type_computed && fruit_peel_type_computed !== '正常';
  const container_taste_computed = useWatch('container_taste', form);
  const container_taste_required = container_taste_computed && container_taste_computed === '其他';
  const carton_condition_type_computed = useWatch('carton_condition_type', form);
  const carton_condition_type_required = carton_condition_type_computed && carton_condition_type_computed === '潮湿';
  const bear_fruit_computed = useWatch('bear_fruit', form);
  const bear_fruit_required = isPureNumber(bear_fruit_computed);
  // const durian_fruit_computed = useWatch('durian_fruit', form);
  // const durian_fruit_required = isPureNumber(durian_fruit_computed);
  const dead_fruit_computed = useWatch('dead_fruit', form);
  const dead_fruit_required = isPureNumber(dead_fruit_computed);
  const cleft_fruit_computed = useWatch('cleft_fruit', form);
  // const cleft_fruit_required = isPureNumber(cleft_fruit_computed);
  const cleft_fruit_low_computed = useWatch('cleft_fruit_low', form);
  const cleft_fruit_low_required = isPureNumber(cleft_fruit_low_computed);
  const cleft_fruit_middle_computed = useWatch('cleft_fruit_middle', form);
  const cleft_fruit_middle_required = isPureNumber(cleft_fruit_middle_computed);
  const cleft_fruit_high_computed = useWatch('cleft_fruit_high', form);
  const cleft_fruit_high_required = isPureNumber(cleft_fruit_high_computed);
  // const damage_fruit_computed = useWatch('damage_fruit', form);
  // const damage_fruit_required = isPureNumber(damage_fruit_computed);
  const sample_number_computed = useWatch('sample_number', form);
  const total_number_computed = useWatch('total_number', form);
  const red_thorn_fruit_computed = useWatch('red_thorn_fruit', form);
  const brown_fruit_computed = useWatch('brown_fruit', form);
  const whole_green_fruit_computed = useWatch('whole_green_fruit', form);
  const other_fruit_computed = useWatch('other_fruit', form);
  const wormhole_fruit_computed = useWatch('wormhole_fruit', form);
  const wormhole_fruit_required = isPureNumber(wormhole_fruit_computed);
  const rotten_fruit_computed = useWatch('rotten_fruit', form);
  const rotten_fruit_required = isPureNumber(rotten_fruit_computed);
  const sugar_sampling_computed = useWatch('sugar_sampling_type', form);
  const sugar_sampling1_computed = useWatch('sugar_sampling1', form);
  const sugar_sampling2_computed = useWatch('sugar_sampling2', form);
  const sugar_sampling3_computed = useWatch('sugar_sampling3', form);
  const shuck_other_fruit_computed = useWatch('shuck_other_fruit', form);
  const shuck_other_fruit_required = isPureNumber(shuck_other_fruit_computed);
  // const average_weight_computed = useWatch('average_weight', form);
  // const package_weight_computed = useWatch('package_weight', form);
  // const standard_weight_computed = useWatch('standard_weight', form);
  const box_in_humidity_computed = useWatch('box_in_humidity', form);
  const { humidity_level, humidity_color } = useHumidityLevel(box_in_humidity_computed);
  const container_head = useWatch('container_temperature_head', form);
  const container_middle = useWatch('container_temperature_middle', form);
  const container_end = useWatch('container_temperature_end', form);
  const core_1_t = useWatch('core_temperature1', form);
  const core_2_t = useWatch('core_temperature2', form);
  const core_3_t = useWatch('core_temperature3', form);
  const fruit_house_number_computed = useWatch('fruit_house_number', form);
  const fruit_house_number_3_computed = useWatch('fruit_house_number_3', form);
  const fruit_house_number_35_computed = useWatch('fruit_house_number_35', form);
  const fruit_house_number_4_computed = useWatch('fruit_house_number_4', form);
  const fruit_color_1_percent_computed = useWatch('fruit_color_1', form);
  const fruit_color_2_percent_computed = useWatch('fruit_color_2', form);
  const fruit_color_3_percent_computed = useWatch('fruit_color_3', form);
  const fruit_color_4_percent_computed = useWatch('fruit_color_4', form);
  const fruit_stalk_broken_percent_computed = useWatch('fruit_stalk_broken', form);
  const fruit_stalk_lacking_percent_computed = useWatch('fruit_stalk_lacking', form);
  const fruit_stalk_rotten_percent_computed = useWatch('fruit_stalk_rotten', form);
  //房数
  const computed_fruit_house_number_3_percent = () => base_computed('fruit_house_number_3_percent', fruit_house_number_3_computed, fruit_house_number_computed);
  const computed_fruit_house_number_35_percent = () => base_computed('fruit_house_number_35_percent', fruit_house_number_35_computed, fruit_house_number_computed);
  const computed_fruit_house_number_4_percent = () => base_computed('fruit_house_number_4_percent', fruit_house_number_4_computed, fruit_house_number_computed);
  const computed_fruit_house_number_percent = () => base_computed('fruit_house_number_percent', fruit_house_number_computed, total_number_computed);
  //颜色
  const computed_fruit_color_1_percent = () => base_computed('fruit_color_1_percent', fruit_color_1_percent_computed, total_number_computed);
  const computed_fruit_color_2_percent = () => base_computed('fruit_color_2_percent', fruit_color_2_percent_computed, total_number_computed);
  const computed_fruit_color_3_percent = () => base_computed('fruit_color_3_percent', fruit_color_3_percent_computed, total_number_computed);
  const computed_fruit_color_4_percent = () => base_computed('fruit_color_4_percent', fruit_color_4_percent_computed, total_number_computed);
  //果柄
  const computed_fruit_stalk_broken_percent = () => base_computed('fruit_stalk_broken_percent', fruit_stalk_broken_percent_computed, total_number_computed);
  const computed_fruit_stalk_lacking_percent = () => base_computed('fruit_stalk_lacking_percent', fruit_stalk_lacking_percent_computed, total_number_computed);
  const computed_fruit_stalk_rotten_percent = () => base_computed('fruit_stalk_rotten_percent', fruit_stalk_rotten_percent_computed, total_number_computed);
  const computed_fruit_stalk_number_percent = () => base_computed('fruit_stalk_number_percent', computed_fruit_stalk_number(), total_number_computed);
  //果皮缺陷
  const computed_poor_fruit_shape_number_percent = () => base_computed('poor_fruit_shape_number_percent', poor_fruit_shape_number_computed, total_number_computed);
  const computed_red_thorn_fruit_percent = () => base_computed('red_thorn_fruit_percent', red_thorn_fruit_computed, total_number_computed);
  const computed_brown_fruit_percent = () => base_computed('brown_fruit_percent', brown_fruit_computed, total_number_computed);
  const computed_whole_green_fruit_percent = () => base_computed('whole_green_fruit_percent', whole_green_fruit_computed, total_number_computed);
  const computed_other_fruit_percent = () => base_computed('other_fruit_percent', other_fruit_computed, total_number_computed);
  const computed_fruit_peel_number_percent = () => base_computed('brown_fruit_total_percent', computed_fruit_peel_number(), total_number_computed);
  const computed_bear_fruit_percent = () => base_computed('bear_fruit_percent', bear_fruit_computed, total_number_computed);
  const computed_dead_fruit_percent = () => base_computed('dead_fruit_percent', dead_fruit_computed, total_number_computed);
  // const computed_durian_fruit_percent = () => base_computed('durian_fruit_percent', durian_fruit_computed, total_number_computed);
  // const computed_damage_fruit_percent = () => base_computed('damage_fruit_percent', damage_fruit_computed, total_number_computed);
  const computed_wormhole_fruit_percent = () => base_computed('wormhole_fruit_percent', wormhole_fruit_computed, total_number_computed);
  const computed_rotten_fruit_percent = () => base_computed('rotten_fruit_percent', rotten_fruit_computed, total_number_computed);
  // const computed_cleft_fruit_percent = () => base_computed('cleft_fruit_percent', cleft_fruit_computed, total_number_computed);
  const computed_cleft_fruit_low_percent = () => base_computed('cleft_fruit_low_percent', cleft_fruit_low_computed, total_number_computed);
  const computed_cleft_fruit_middle_percent = () => base_computed('cleft_fruit_middle_percent', cleft_fruit_middle_computed, total_number_computed);
  const computed_cleft_fruit_high_percent = () => base_computed('cleft_fruit_high_percent', cleft_fruit_high_computed, total_number_computed);
  const computed_cleft_fruit_number_percent = () => base_computed('cleft_fruit_number_percent', computed_cleft_fruit_number(), total_number_computed);
  const computed_shuck_other_fruit_percent = () => base_computed('shuck_other_fruit_percent', shuck_other_fruit_computed, total_number_computed);
  const computed_shuck_other_fruit_number_percent = () => base_computed('shuck_other_fruit_number_percent', computed_shuck_other_fruit_number(), total_number_computed);
  const fruit_flesh_rot_computed = useWatch('fruit_flesh_rot', form);
  const fruit_flesh_rot_required = isPureNumber(fruit_flesh_rot_computed);
  const fruit_flesh_blight_computed = useWatch('fruit_flesh_blight', form);
  const fruit_flesh_blight_required = isPureNumber(fruit_flesh_blight_computed);
  const fruit_flesh_wormy_computed = useWatch('fruit_flesh_wormy', form);
  const fruit_flesh_wormy_required = isPureNumber(fruit_flesh_wormy_computed);
  const fruit_flesh_burning_computed = useWatch('fruit_flesh_burning', form);
  const fruit_flesh_burning_required = isPureNumber(fruit_flesh_burning_computed);
  const computed_fruit_flesh_rot_percent = () => base_computed('fruit_flesh_rot_percent', fruit_flesh_rot_computed, total_number_computed);
  const computed_fruit_flesh_blight_percent = () => base_computed('fruit_flesh_blight_percent', fruit_flesh_blight_computed, total_number_computed);
  const computed_fruit_flesh_wormy_percent = () => base_computed('fruit_flesh_wormy_percent', fruit_flesh_wormy_computed, total_number_computed);
  const computed_fruit_flesh_burning_percent = () => base_computed('fruit_flesh_burning_percent', fruit_flesh_burning_computed, total_number_computed);
  const computed_fruit_flesh_number_percent = () => base_computed('fruit_flesh_number_percent', computed_fruit_flesh_number(), total_number_computed);
  const computed_cleft_fruit_number = useCallback(() => {//开裂总计
    const total = (Number(cleft_fruit_computed) || 0) + (Number(cleft_fruit_low_computed) || 0) + (Number(cleft_fruit_middle_computed) || 0) + (Number(cleft_fruit_high_computed) || 0);
    return Number(total.toFixed(2));
  }, [cleft_fruit_computed, cleft_fruit_low_computed, cleft_fruit_middle_computed, cleft_fruit_high_computed]);
  const computed_fruit_stalk_number = useCallback(() => {//果柄合计 
    const broken = Number(fruit_stalk_broken_percent_computed) || 0;
    const lacking = Number(fruit_stalk_lacking_percent_computed) || 0;
    const rotten = Number(fruit_stalk_rotten_percent_computed) || 0;
    const total = broken + lacking + rotten;
    if (total > 100) {
      message.warning('果柄各类问题百分比合计超过100%，请检查数值！');
    }
    return Number(total.toFixed(2));
  }, [fruit_stalk_broken_percent_computed, fruit_stalk_lacking_percent_computed, fruit_stalk_rotten_percent_computed]);
  const computed_fruit_peel_number = useCallback(() => {//果皮缺陷合计
    const red = Number(red_thorn_fruit_computed) || 0;
    const brown = Number(brown_fruit_computed) || 0;
    const green = Number(whole_green_fruit_computed) || 0;
    const other = Number(other_fruit_computed) || 0;
    const total = red + brown + green + other;
    if (total > 100) {
      message.warning('果皮缺陷各类问题百分比合计超过100%，请检查数值！');
    }
    return Number(total.toFixed(2));
  }, [red_thorn_fruit_computed, brown_fruit_computed, whole_green_fruit_computed, other_fruit_computed]);
  const computed_container_temperature_average = useCallback(() => { // 柜头，中，尾 平均温度
    const getNumber = (value) => isPureNumber(value) ? Number(value) : null;
    const head = getNumber(container_head);
    const middle = getNumber(container_middle);
    const end = getNumber(container_end);
    const validNums = [head, middle, end].filter(num => num !== null);
    if (validNums.length === 0) {
      return '';
    }
    const sum = validNums.reduce((total, num) => total + num, 0);
    const average = sum / validNums.length;
    return average.toFixed(2);
  }, [container_head, container_middle, container_end]);
  const computed_core_temperature_average = useCallback(() => {// 果心平均温度
    const getNumber = (value) => isPureNumber(value) ? Number(value) : null;
    const core_1 = getNumber(core_1_t);
    const core_2 = getNumber(core_2_t);
    const core_3 = getNumber(core_3_t);
    const validNums = [core_1, core_2, core_3].filter(num => num !== null);
    if (validNums.length === 0) {
      return '';
    }
    const sum = validNums.reduce((total, num) => total + num, 0);
    const average = sum / validNums.length;
    return average.toFixed(2);
  }, [core_1_t, core_2_t, core_3_t]);
  const computed_shuck_other_fruit_number = useCallback(() => {//发霉总计
    const total = (Number(wormhole_fruit_computed) || 0) + (Number(rotten_fruit_computed) || 0) + (Number(shuck_other_fruit_computed) || 0);
    return Number(total.toFixed(2));
  }, [wormhole_fruit_computed, rotten_fruit_computed, shuck_other_fruit_computed]);
  const computed_fruit_flesh_number = useCallback(() => {//果肉问题总计
    const total = (Number(fruit_flesh_rot_computed) || 0) + (Number(fruit_flesh_blight_computed) || 0) + (Number(fruit_flesh_wormy_computed) || 0) + (Number(fruit_flesh_burning_computed) || 0);
    return Number(total.toFixed(2));
  }, [fruit_flesh_rot_computed, fruit_flesh_blight_computed, fruit_flesh_wormy_computed, fruit_flesh_burning_computed]);
  const computed_average_sugar = useCallback(() => {// 平均糖度
    const sugarValues = [];
    if (sugar_sampling1_computed) sugarValues.push(Number(sugar_sampling1_computed));
    if (sugar_sampling2_computed) sugarValues.push(Number(sugar_sampling2_computed));
    if (sugar_sampling3_computed) sugarValues.push(Number(sugar_sampling3_computed));
    if (sugarValues.length === 0) return 0;
    const total = sugarValues.reduce((sum, value) => sum + value, 0);
    const average = total / sugarValues.length;
    return Number(average.toFixed(1));
  }, [sugar_sampling1_computed, sugar_sampling2_computed, sugar_sampling3_computed]);
  useEffect(() => {
    const average = computed_container_temperature_average();
    form.setFieldsValue({ container_temperature_average: average });
  }, [container_head, container_middle, container_end, computed_container_temperature_average, form]);

  useEffect(() => {
    const average = computed_core_temperature_average();
    form.setFieldsValue({ core_temperature_average: average });
  }, [core_1_t, core_2_t, core_3_t, computed_core_temperature_average, form]);

  // 监听果柄相关数据变化，更新合计值
  useEffect(() => {
    const total = computed_fruit_stalk_number();
    form.setFieldsValue({ fruit_stalk_number: total });
  }, [fruit_stalk_broken_percent_computed, fruit_stalk_lacking_percent_computed, fruit_stalk_rotten_percent_computed, computed_fruit_stalk_number, form]);

  // 监听果皮缺陷相关数据变化，更新合计值
  useEffect(() => {
    const total = computed_fruit_peel_number();
    form.setFieldsValue({ fruit_peel_number: total });
  }, [red_thorn_fruit_computed, brown_fruit_computed, whole_green_fruit_computed, other_fruit_computed, computed_fruit_peel_number, form]);

  // 监听开裂总计变化
  useEffect(() => {
    const cleft_fruit_number = computed_cleft_fruit_number();
    form.setFieldsValue({ cleft_fruit_number });
  }, [cleft_fruit_computed, cleft_fruit_low_computed, cleft_fruit_middle_computed, cleft_fruit_high_computed, computed_cleft_fruit_number, form]);

  // 监听发霉总计变化
  useEffect(() => {
    const shuck_other_fruit_number = computed_shuck_other_fruit_number();
    form.setFieldsValue({ shuck_other_fruit_number });
  }, [wormhole_fruit_computed, rotten_fruit_computed, shuck_other_fruit_computed, computed_shuck_other_fruit_number, form]);

  // 监听果肉问题总计变化
  useEffect(() => {
    const fruit_flesh_number = computed_fruit_flesh_number();
    form.setFieldsValue({ fruit_flesh_number });
  }, [fruit_flesh_rot_computed, fruit_flesh_blight_computed, fruit_flesh_wormy_computed, fruit_flesh_burning_computed, computed_fruit_flesh_number, form]);

  // 监听平均糖度变化


  useEffect(() => {
    const average_sugar = computed_average_sugar();
    form.setFieldsValue({ average_sugar });
  }, [sugar_sampling1_computed, sugar_sampling2_computed, sugar_sampling3_computed, computed_average_sugar, form]);

  const columns = [
    {
      title: '商品名称',
      dataIndex: 'name',
      key: 'name',
      width: 300
    },
    {
      title: '单位重量(kg)',
      dataIndex: 'base_factor',
      key: 'base_factor',
      width: 100
    },
    {
      title: '标准到货',
      dataIndex: 'standard_number',
      key: 'standard_number',
      width: 200,
      render: (text, record, index) => {
        const { sale_id } = record;
        return <div style={{ display: 'flex', 'alignItems': 'center' }}>
          <Form.Item size='small' name={`standard_number_${sale_id}_${index}`} defaultValue={record?.standard_number ? record?.standard_number : record?.deliver_number} noStyle wrapperCol={{ span: 24 }} rules={[{ required: true, message: `请填写标准到货数量!`, },]}>
            <InputNumber disabled={!canEdit} controls={false} min={0} precision={0} onBlur={(e) => standard_number_blur(e, record, index)} defaultValue={record?.deliver_number} />
          </Form.Item>
          <span>箱</span>
        </div>;
      }
    },
    {
      title: '占比',
      dataIndex: 'standard_percent',
      key: 'standard_percent',
      width: 100,
      render: (text, record, index) => {
        const { standard_number } = record;
        if (isPureNumber(standard_number)) {
          const total = (dataSource || []).reduce((pre, next) => pre + Number(next.standard_number), 0);
          const current_percent = parseFloat(standard_number / total) * 100;
          return isPureNumber(current_percent) && total ? current_percent.toFixed(2) + '%' : '';
        } else {
          return '';
        }
      }
    },
    {
      title: '实际到货',
      dataIndex: 'actual_number',
      key: 'actual_number',
      width: 200,
      render: (text, record, index) => {
        const { sale_id } = record;
        return <Form.Item size='small' colon={false} wrapperCol={{ span: 24 }}>
          <div style={{ display: 'flex', 'alignItems': 'center' }}>
            <Form.Item size='small' name={`actual_number_${sale_id}_${index}`} noStyle wrapperCol={{ span: 24 }} rules={[{ required: true, message: `请填写实际到货数量!`, },]}>
              <InputNumber defaultValue={record?.actual_number ? record?.actual_number:  record?.receive_number} disabled={!canEdit} controls={false} min={0} precision={0} onBlur={(e) => actual_number_blur(e, record, index)} />
            </Form.Item>
            <span>箱</span>
          </div>
        </Form.Item>;
      }
    },
    {
      title: '占比',
      width: 100,
      dataIndex: 'actual_percent',
      key: 'actual_percent',
      render: (text, record, index) => {
        const { actual_number } = record;
        if (isPureNumber(actual_number)) {
          const total = (dataSource || []).reduce((pre, next) => pre + Number(next.actual_number), 0);
          const current_percent = parseFloat(actual_number / total) * 100;
          return isPureNumber(current_percent) && total ? current_percent.toFixed(2) + '%' : '';
        } else {
          return '';
        }
      }
    },
    {
      title: '偏差',
      width: 100,
      dataIndex: 'deviation',
      key: 'deviation',
      render: (text, record, index) => {
        const { sale_id } = record;
        const standard_number = getFieldValue(`standard_number_${sale_id}_${index}`);
        const actual_number = getFieldValue(`actual_number_${sale_id}_${index}`);
        return isPureNumber(actual_number) && isPureNumber(standard_number) ? `${(actual_number || 0) - (standard_number || 0)}箱` : '';
      }
    },
  ];
  const columns2 = [
    {
      title: '商品名称',
      dataIndex: 'name',
      key: 'name',
      width: 300
    },
    {
      title: '抽检数量',
      dataIndex: 'sample_number',
      key: 'sample_number',
      render: (text, record, index) => {
        const { sale_id } = record;
        return <div style={{ display: 'flex', 'alignItems': 'center' }}>
          <Form.Item size='small' name={`sample_number_${sale_id}_${index}`} noStyle rules={[{ required: true, message: '请填写抽检数量!', },]}>
            <InputNumber disabled={!canEdit} controls={false} min={0} precision={0} onBlur={(e) => sample_number_blur(e, record, index)} />
          </Form.Item>
          <span>箱</span>
        </div>;
      }
    },
    {
      title: '占比',
      width: 300,
      dataIndex: 'sample_percent',
      key: 'sample_percent',
      render: (text, record) => {
        const { sample_number } = record;
        if (isPureNumber(sample_number)) {
          const current_percent = isPureNumber(sample_number_computed) && sample_number_computed ? parseFloat(sample_number / sample_number_computed) * 100 : '';
          return isPureNumber(current_percent) ? current_percent.toFixed(2) + '%' : '';
        } else {
          return '';
        }
      }
    },
  ];
  const columns3 = [
    {
      title: '柜位置',
      dataIndex: 'position',
      key: 'position'
    },
    {
      title: '称重数量(箱数)',
      dataIndex: 'single_weight_container_number',
      key: 'single_weight_container_number'
    },
    {
      title: '称重(kg)',
      dataIndex: 'weight_info',
      key: 'weight_info',
      render: (text, record, posIdx) => {
        const weightIdx = weight_data.findIndex(item =>
          item.weight_source.some(p => p.position === record.position)
        );
        return (
          <div>
            {record.single_data.map((data, dataIdx) => (
              <div key={dataIdx} style={{ marginBottom: 8, display: 'flex', alignItems: 'center', gap: 8 }}>
                <span>{dataIdx + 1}</span>
                <Form.Item size='small' colon={false} name={`single_weight_number_${weightIdx}_${posIdx}_${dataIdx}`} rules={[{ required: true, message: '请输入称重!', },]}>
                  <InputNumber
                    placeholder='请输入称重'
                    precision={2}
                    onChange={(value) => handleSingleWeightChange(value, weightIdx, posIdx, dataIdx)}
                    style={{ width: 120 }}
                    disabled={!canEdit}
                    defaultValue={data.single_weight_number}
                  />
                </Form.Item>
                <Form.Item size='small' colon={false} name={`single_weight_pic_${weightIdx}_${posIdx}_${dataIdx}`} >
                  <Upload
                    name="file"
                    headers={{ token: localStorage.getItem('token') }}
                    showUploadList={false}
                    fileList={(data?.single_weight_pic || [])}
                    customRequest={(file) => weight_change(file, weightIdx, posIdx, dataIdx)}
                    accept="image/png, image/jpeg"
                    maxCount={1}
                    disabled={!canEdit}
                  >
                    <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                      {(data?.single_weight_pic || []).length ? '' : <Button icon={<UploadOutlined />}>上传图片</Button>}
                    </div>
                  </Upload>
                  {(data?.single_weight_pic || []).length ? <div style={{ width: 50, height: 40 }}><Index list={data?.single_weight_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => { weight_remove(e, weightIdx, posIdx, dataIdx); }} /></div> : ''}
                </Form.Item>
              </div>
            ))}
          </div>
        );
      }
    },
    {
      title: '平均毛重(kg)',
      dataIndex: 'average_gross_weight',
      key: 'average_gross_weight',
      render: (text) => text || '-'
    },
    {
      title: '包装重量(kg)',
      dataIndex: 'package_weight',
      key: 'package_weight',
      render: (text, record, posIdx) => {
        const weightIdx = weight_data.findIndex(item =>
          item.weight_source.some(p => p.position === record.position)
        );
        return (
          <Form.Item size='small' colon={false} name={`package_weight_${weightIdx}_${posIdx}`} rules={[{ required: true, message: '请输入包装重量!', },]}>
            <InputNumber
              placeholder='请输入包装重量'
              precision={2}
              value={text}
              onChange={(value) => handlePackageWeightChange(value, weightIdx, posIdx)}
              style={{ width: 100 }}
              disabled={!canEdit}
            />
          </Form.Item>
        );
      }
    },
    {
      title: '平均净重(kg)',
      dataIndex: 'average_net_weight',
      key: 'average_net_weight',
      render: (text) => text || '-'
    },
    {
      title: '偏差占比',
      dataIndex: 'deviation_proportion',
      key: 'deviation_proportion',
      render: (text) => text || '-'
    },
    {
      title: <>
        是否达标
        <Tooltip title="实际净重小于标准值被视为不合格；重量实际净重大于等于标准值则视为合格">
          <InfoCircleOutlined style={{ marginLeft: 4, cursor: 'help' }} />
        </Tooltip>
      </>,
      dataIndex: 'is_standard',
      key: 'is_standard',
      render: (text) => text || '-'
    }
  ];
  const actual_number_blur = (e, record, index) => {
    const timer = setTimeout(() => {
      const { sale_id } = record;
      const actual_number = getFieldValue(`actual_number_${sale_id}_${index}`);
      dataSource[index].actual_number = isPureNumber(actual_number) ? actual_number : '';
      setDataSource([...dataSource]);
      computed_data_source([...dataSource]);
      clearTimeout(timer);
    });
  };
  const standard_number_blur = (e, record, index) => {
    const timer = setTimeout(() => {
      const { sale_id } = record;
      const standard_number = getFieldValue(`standard_number_${sale_id}_${index}`);
      dataSource[index].standard_number = isPureNumber(standard_number) ? standard_number : '';
      setDataSource([...dataSource]);
      computed_data_source([...dataSource]);
      clearTimeout(timer);
    });
  };
  const sample_number_blur = (e, record, index) => {
    const timer = setTimeout(() => {
      const { sale_id } = record;
      const sample_number = getFieldValue(`sample_number_${sale_id}_${index}`);
      const newDataSource = [...dataSource];
      newDataSource[index].sample_number = sample_number;
      setDataSource(newDataSource);
      computed_weight_source(newDataSource);
      clearTimeout(timer);
    });
  };

  const computed_weight_source = useCallback((currentDataSource) => {
    const weightGroup = {};
    currentDataSource.forEach(item => {
      const weight = item.base_factor;
      const sampleNum = Number(item.sample_number) || 0;
      if (!weightGroup[weight]) {
        weightGroup[weight] = {
          totalSampleNumber: 0,
          skuWeight: weight
        };
      }
      weightGroup[weight].totalSampleNumber += sampleNum;
    });
    const newWeightData = Object.values(weightGroup).map(group => {
      const weightNumber = group.totalSampleNumber;
      const singleBoxNumber = Math.floor(weightNumber / 3);
      const createSingleData = () => {
        const arr = [];
        for (let i = 0; i < singleBoxNumber; i++) {
          arr.push({
            single_weight_number: '',
            single_weight_pic: []
          });
        }
        return arr;
      };
      const createPositionData = (position) => ({
        position,
        single_weight_container_number: singleBoxNumber.toString(),
        single_data: createSingleData(),
        average_gross_weight: '',
        package_weight: '',
        average_net_weight: '',
        deviation_proportion: '',
        is_standard: ''
      });
      return {
        base_factor: group.skuWeight,
        weight_number: weightNumber,
        weight_source: [
          createPositionData('柜头'),
          createPositionData('柜中'),
          createPositionData('柜尾')
        ]
      };
    });
    setWeightData(newWeightData);
  }, []);
  const handleSingleWeightChange = (value, weightIdx, posIdx, dataIdx) => {
    const newWeightData = JSON.parse(JSON.stringify(weight_data));
    newWeightData[weightIdx].weight_source[posIdx].single_data[dataIdx].single_weight_number = value;
    const singleDataList = newWeightData[weightIdx].weight_source[posIdx].single_data;
    const validWeights = singleDataList.map(item => Number(item.single_weight_number)).filter(num => !isNaN(num));
    const avgGrossWeight = validWeights.length > 0
      ? (validWeights.reduce((sum, num) => sum + num, 0) / validWeights.length).toFixed(2)
      : '';
    newWeightData[weightIdx].weight_source[posIdx].average_gross_weight = avgGrossWeight;
    const packageWeight = Number(newWeightData[weightIdx].weight_source[posIdx].package_weight) || 0;
    if (avgGrossWeight) {
      const avgNetWeight = (Number(avgGrossWeight) - packageWeight).toFixed(2);
      newWeightData[weightIdx].weight_source[posIdx].average_net_weight = avgNetWeight;

      const skuWeight = newWeightData[weightIdx].base_factor;
      const deviationRatio = skuWeight
        ? (((Number(avgNetWeight) - skuWeight) / skuWeight) * 100).toFixed(2) + '%'
        : '';
      newWeightData[weightIdx].weight_source[posIdx].deviation_proportion = deviationRatio;
      // 实际净重小于标准值被视为不合格；重量实际净重大于等于标准值则视为合格
      newWeightData[weightIdx].weight_source[posIdx].is_standard = Number(avgNetWeight) >= skuWeight ? '达标' : '不达标';
    }
    setWeightData(newWeightData);
  };
  const handlePackageWeightChange = (value, weightIdx, posIdx) => {
    const newWeightData = [...weight_data];
    newWeightData[weightIdx].weight_source[posIdx].package_weight = value;
    const avgGrossWeight = Number(newWeightData[weightIdx].weight_source[posIdx].average_gross_weight) || 0;
    if (avgGrossWeight) {
      const avgNetWeight = (avgGrossWeight - Number(value)).toFixed(2);
      newWeightData[weightIdx].weight_source[posIdx].average_net_weight = avgNetWeight;
      // 重新计算偏差占比和是否达标
      const skuWeight = +newWeightData[weightIdx].base_factor;
      const deviationRatio = skuWeight
        ? (((Number(avgNetWeight) - skuWeight) / skuWeight) * 100).toFixed(2) + '%'
        : '';
      newWeightData[weightIdx].weight_source[posIdx].deviation_proportion = deviationRatio;
      newWeightData[weightIdx].weight_source[posIdx].is_standard = Number(avgNetWeight) >= skuWeight ? '达标' : '不达标';
    }
    setWeightData(newWeightData);
  };

  const onFinish = () => {
    save(2);
  };
  const onFinishFailed = () => {
    message.error('信息未填写完整!');
  };

  const computed_data_source = (data) => {
    const len = (data || []).length;
    const standard_numbers = (data || []).reduce((pre, next) => pre + Number(next.standard_number), 0);
    const standard_numbers_check = len ? (data || []).every(item => isPureNumber(item.standard_number)) : false;
    const actual_numbers_check = len ? (data || []).every(item => isPureNumber(item.actual_number)) : false;
    const actual_numbers = actual_numbers_check ? (data || []).reduce((pre, next) => pre + Number(next.actual_number || 0), 0) : '';
    const deviation = standard_numbers_check && actual_numbers_check ? (data || []).reduce((pre, next) => pre + (Number(next.actual_number || 0) - Number(next.standard_number || 0)), 0) + '箱' : '';
    setComputedSource({ standard_numbers, standard_numbers_check, actual_numbers_check, actual_numbers, deviation }); //合计
  };
  const computed_sample_number_percent = () => {
    const { actual_numbers_check, actual_numbers } = computedSource;
    const sample_number_percent = (sample_number_computed && actual_numbers_check) ? ((sample_number_computed / actual_numbers) * 100).toFixed(2) : '';
    const timer = setTimeout(() => {
      setFieldsValue({ sample_number_percent });
      clearTimeout(timer);
    });
  };

  const base_computed = (key, a, b) => {
    const percent = isPureNumber(a) && b ? ((a / b) * 100).toFixed(2) : '';
    const timer = setTimeout(() => {
      setFieldsValue({ [key]: percent });
      clearTimeout(timer);
    });
  };


  // 监听开裂总计变化
  useEffect(() => {
    const cleft_fruit_number = computed_cleft_fruit_number();
    form.setFieldsValue({ cleft_fruit_number });
  }, [cleft_fruit_computed, cleft_fruit_low_computed, cleft_fruit_middle_computed, cleft_fruit_high_computed, computed_cleft_fruit_number, form]);

  // 监听发霉总计变化
  useEffect(() => {
    const shuck_other_fruit_number = computed_shuck_other_fruit_number();
    form.setFieldsValue({ shuck_other_fruit_number });
  }, [wormhole_fruit_computed, rotten_fruit_computed, shuck_other_fruit_computed, computed_shuck_other_fruit_number, form]);

  // 监听果肉问题总计变化
  useEffect(() => {
    const fruit_flesh_number = computed_fruit_flesh_number();
    form.setFieldsValue({ fruit_flesh_number });
  }, [fruit_flesh_rot_computed, fruit_flesh_blight_computed, fruit_flesh_wormy_computed, fruit_flesh_burning_computed, computed_fruit_flesh_number, form]);

  // 监听平均糖度变化
  useEffect(() => {
    const average_sugar = computed_average_sugar();
    form.setFieldsValue({ average_sugar });
  }, [sugar_sampling1_computed, sugar_sampling2_computed, sugar_sampling3_computed, computed_average_sugar, form]);

  useEffect(() => {
    try {
      async function getQualityBase() {
        let company_id = window.localStorage.getItem('companyId');
        let user_id = window.localStorage.getItem('user_id');
        const { data: { code, msg, data } } = await getQualityBaseInfo(({ order_no: order_id, company_id, user_id }));
        if (+code === 0) {
          setQualityBaseInfo(data);
          const { address_list = [], product_info = [], last_warehouse_info = {}, container_no = [] } = data;
          const standard_weight = product_info?.[0]?.base_factor;
          form.setFieldsValue({
            address_id: address_list[0].id,
            arrival_time: currentTime,
            quality_time: currentTime,
            container_time: currentTime,
            standard_weight,
            warehouse_name: last_warehouse_info?.warehouse_name,
            warehouse_phone: last_warehouse_info?.warehouse_phone,
            container_no: container_no?.[0]
          });
          setStandardWeight(standard_weight);
          const processedProductInfo = (product_info || []).map(item => {
            return {
              ...item,
              standard_number: item.standard_number && item.standard_number !== 0 ? item.standard_number : item?.deliver_number,
              actual_number: item.actual_number && item.actual_number !== 0 ? item.actual_number : item?.receive_number
            };
          });
          setDataSource([...processedProductInfo]);
          computed_weight_source([...processedProductInfo]);
          computed_data_source([...processedProductInfo]);
        } else {
          message.error(msg);
        }
      }
      async function getQualityDetailInfo() {
        const { data: { code, msg, data } } = await getQualityDetail(({ quality_no: quality_id }));
        if (+code === 0) {
          formatDetailData(data);
        } else {
          message.error(msg);
        }
      }
      (async () => {
        await getQualityBase();
        if (quality_id !== '0') {
          await getQualityDetailInfo();
        }
        setCanEdit(type === '1');
      })();
    } finally {
      setLoading(true);
    }
    return setInfo({ ...deepClone(baseInfo) });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [order_id, quality_id, type]);
  const formatDetailData = (detail_info = {}) => {
    const { base_info = {}, product_info = [], container_info = {}, sample_info = {}, weight_info = {}, fruit_shape = {}, colour_info = {}, shuck_info = {}, flesh_info = {}, other_info = {}, buy_comments = '', id, quality_no, status, order_no, carton_packaging = {}, fruit_handle = {}, fruit_stalk = {}, weight_data = [] } = detail_info;
    const { container_no, arrival_time, temperature, car_number, car_type, address_id, warehouse_name, warehouse_phone, finance_name, finance_phone, car_number_pic = [], driver_license, driver_license_pic = [], driver_name, driver_number, warehouse_position, finance_position, sales_name, sales_phone, sales_position, quality_time } = base_info;
    const dataSource = product_info.map(item => {
      return {
        ...item,
        standard_number: item.standard_number && item.standard_number !== 0 ? item.standard_number : item?.deliver_number,
        actual_number: item.actual_number && item.actual_number !== 0 ? item.actual_number : item?.receive_number
      };
    });
    const {
      // container_time, 
      air_temperature,
      outlet_temperature, return_air_temperature, box_in_temperature, core_temperature, container_taste, container_taste_desc, container_pic = [], outlet_temperature_pic = [], return_air_temperature_pic = [], box_in_temperature_pic = [], core_temperature_pic = [], air_temperature_pic = [], box_in_humidity, box_in_humidity_pic = [], carton_condition_type, carton_condition_number, carton_condition_number_pic = [],
      carton_condition_number_video = [], container_temperature_head, container_temperature_head_pic = [], container_temperature_middle, container_temperature_middle_pic = [], container_temperature_end, container_temperature_end_pic = [], core_temperature1, core_temperature1_pic = [], core_temperature2, core_temperature2_pic = [], core_temperature3, core_temperature3_pic = [], IOT1_no, IOT1_no_temperature, IOT1_no_temperature_pic = [],
      IOT2_no, IOT2_no_temperature, IOT2_no_temperature_pic = [], IOT3_no, IOT3_no_temperature, IOT3_no_temperature_pic = [] } = container_info;
    const { sample_number, total_number, } = sample_info;
    const { weight_pic = [], average_weight, package_weight, deviation, is_standard, } = weight_info;
    const { poor_fruit_shape_number, poor_fruit_shape_number_pic = [], poor_fruit_shape_describe, poor_fruit_shape, fruit_house, fruit_house_number, fruit_house_shape_number_pic = [], fruit_house_number_3, fruit_house_number_3_pic = [],
      fruit_house_number_35, fruit_house_number_35_pic = [], fruit_house_number_4, fruit_house_number_4_pic = [] } = fruit_shape;
    const { fruit_color, colour_info_describe, red_thorn_fruit, brown_fruit, whole_green_fruit, other_fruit, fruit_color_1, fruit_color_1_pic = [], fruit_color_2, fruit_color_2_pic = [], fruit_color_3, fruit_color_3_pic = [], fruit_color_4, fruit_color_4_pic = [], fruit_peel_type, fruit_peel_number, } = colour_info;
    const { bear_fruit, damage_fruit, wormhole_fruit, rotten_fruit, shuck_other_fruit, cleft_fruit, maturity, shuck_info_describe, bear_fruit_pic = [], damage_fruit_pic = [], cleft_fruit_pic = [], hardness_fruit_video = [], hardness_fruit, bear_fruit_describe, dead_fruit, dead_fruit_pic = [], dead_fruit_describe, durian_fruit, durian_fruit_pic = [], durian_fruit_describe, damage_fruit_describe,
      bear_fruit_video = [], dead_fruit_video = [], fruit_shell_type, shuck_other_fruit_pic = [], cleft_fruit_low, cleft_fruit_low_pic = [], cleft_fruit_middle, cleft_fruit_middle_pic = [], cleft_fruit_high, cleft_fruit_high_pic = [], fruit_shell_in_type, fruit_flesh_type, fruit_flesh_rot, fruit_flesh_rot_pic = [], fruit_flesh_blight, fruit_flesh_blight_pic = [], fruit_flesh_wormy, fruit_flesh_wormy_pic = [], fruit_flesh_burning, fruit_flesh_burning_pic = [],
      wormhole_fruit_pic = [], rotten_fruit_pic = [],
    } = shuck_info;
    const { sugar_sampling, sugar_sampling1, sugar_sampling2, sugar_sampling3, average_sugar, flesh_color, flesh_taste, average_sugar_pic = [], hardness_flesh_video = [], hardness_flesh, sugar_sampling_type, sugar_sampling1_pic = [], sugar_sampling2_pic = [], sugar_sampling3_pic = [], flesh_color_pic = [], } = flesh_info;
    const { inspection_pic = [], inspection_video = [], inspection_report = [], inspection_scene_pic = [], inspection_process_pic = [], inspection_process_video = [], inspection_card_video = [], inspection_scene_video = [] } = other_info;
    const { carton_packaging_sticker_pic = [] } = carton_packaging;
    const { fruit_handle_sticker_pic = [] } = fruit_handle;
    const { fruit_stalk_type, fruit_stalk_broken, fruit_stalk_broken_pic = [], fruit_stalk_lacking, fruit_stalk_lacking_pic = [], fruit_stalk_rotten, fruit_stalk_rotten_pic = [], fruit_stalk_number } = fruit_stalk ?? {};
    const number_options = {};
    for (let item of (dataSource || []).entries()) {
      const [index, data_item = {}] = item;
      const { actual_number, sale_id, sample_number, standard_number } = data_item;
      number_options[`actual_number_${sale_id}_${index}`] = actual_number;
      number_options[`sample_number_${sale_id}_${index}`] = sample_number;
      number_options[`standard_number_${sale_id}_${index}`] = standard_number;
    }
    info.carton_packaging.carton_packaging_sticker_pic = carton_packaging_sticker_pic;
    info.fruit_handle.fruit_handle_sticker_pic = fruit_handle_sticker_pic;
    info.container_info.container_pic = container_pic;
    info.container_info.outlet_temperature_pic = outlet_temperature_pic;
    info.container_info.return_air_temperature_pic = return_air_temperature_pic;
    info.container_info.air_temperature_pic = air_temperature_pic;
    info.container_info.box_in_temperature_pic = box_in_temperature_pic;
    info.container_info.core_temperature_pic = core_temperature_pic;
    info.weight_info.weight_pic = weight_pic;
    info.fruit_shape.poor_fruit_shape_number_pic = poor_fruit_shape_number_pic;
    info.fruit_shape.fruit_house_shape_number_pic = fruit_house_shape_number_pic;
    info.fruit_shape.fruit_house_number_3_pic = fruit_house_number_3_pic;
    info.fruit_shape.fruit_house_number_35_pic = fruit_house_number_35_pic;
    info.fruit_shape.fruit_house_number_4_pic = fruit_house_number_4_pic;
    info.shuck_info.hardness_fruit_video = hardness_fruit_video;
    info.shuck_info.dead_fruit_pic = dead_fruit_pic;
    info.shuck_info.dead_fruit_video = dead_fruit_video;
    info.shuck_info.durian_fruit_pic = durian_fruit_pic;
    info.shuck_info.bear_fruit_pic = bear_fruit_pic;
    info.shuck_info.damage_fruit_pic = damage_fruit_pic;
    info.shuck_info.cleft_fruit_pic = cleft_fruit_pic;
    info.shuck_info.wormhole_fruit_pic = wormhole_fruit_pic;
    info.shuck_info.rotten_fruit_pic = rotten_fruit_pic;
    info.flesh_info.average_sugar_pic = average_sugar_pic;
    info.flesh_info.hardness_flesh_video = hardness_flesh_video;
    info.other_info = other_info;
    info.base_info.car_number_pic = car_number_pic;
    info.base_info.driver_license_pic = driver_license_pic;
    info.container_info.box_in_humidity_pic = box_in_humidity_pic;
    info.container_info.carton_condition_number_pic = carton_condition_number_pic;
    info.container_info.carton_condition_number_video = carton_condition_number_video;
    info.container_info.container_temperature_head_pic = container_temperature_head_pic;
    info.container_info.container_temperature_middle_pic = container_temperature_middle_pic;
    info.container_info.container_temperature_end_pic = container_temperature_end_pic;
    info.container_info.core_temperature1_pic = core_temperature1_pic;
    info.container_info.core_temperature2_pic = core_temperature2_pic;
    info.container_info.core_temperature3_pic = core_temperature3_pic;
    info.container_info.IOT1_no_temperature_pic = IOT1_no_temperature_pic;
    info.container_info.IOT2_no_temperature_pic = IOT2_no_temperature_pic;
    info.container_info.IOT3_no_temperature_pic = IOT3_no_temperature_pic;
    info.shuck_info.shuck_other_fruit_pic = shuck_other_fruit_pic;
    info.shuck_info.cleft_fruit_low_pic = cleft_fruit_low_pic;
    info.shuck_info.cleft_fruit_middle_pic = cleft_fruit_middle_pic;
    info.shuck_info.cleft_fruit_high_pic = cleft_fruit_high_pic;
    info.shuck_info.fruit_flesh_rot_pic = fruit_flesh_rot_pic;
    info.shuck_info.fruit_flesh_blight_pic = fruit_flesh_blight_pic;
    info.shuck_info.fruit_flesh_wormy_pic = fruit_flesh_wormy_pic;
    info.shuck_info.fruit_flesh_burning_pic = fruit_flesh_burning_pic;
    info.shuck_info.bear_fruit_video = bear_fruit_video;
    info.flesh_info.sugar_sampling1_pic = sugar_sampling1_pic;
    info.flesh_info.sugar_sampling2_pic = sugar_sampling2_pic;
    info.flesh_info.sugar_sampling3_pic = sugar_sampling3_pic;
    info.flesh_info.flesh_color_pic = flesh_color_pic;
    info.other_info.inspection_scene_video = inspection_scene_video;
    info.other_info.inspection_scene_pic = inspection_scene_pic;
    info.other_info.inspection_pic = inspection_pic;
    info.other_info.inspection_process_pic = inspection_process_pic;
    info.other_info.inspection_process_video = inspection_process_video;
    info.other_info.inspection_card_video = inspection_card_video;
    info.colour_info.fruit_color_1_pic = fruit_color_1_pic;
    info.colour_info.fruit_color_2_pic = fruit_color_2_pic;
    info.colour_info.fruit_color_3_pic = fruit_color_3_pic;
    info.colour_info.fruit_color_4_pic = fruit_color_4_pic;
    info.fruit_stalk.fruit_stalk_broken_pic = fruit_stalk_broken_pic;
    info.fruit_stalk.fruit_stalk_lacking_pic = fruit_stalk_lacking_pic;
    info.fruit_stalk.fruit_stalk_rotten_pic = fruit_stalk_rotten_pic;
    setDataSource(dataSource);
    setWeightData(weight_data);
    // 更新称重相关的表单字段，确保已有的称重数据正确显示
    (weight_data || []).forEach((weightItem, weightIdx) => {
      weightItem.weight_source.forEach((posItem, posIdx) => {
        posItem.single_data.forEach((singleItem, dataIdx) => {
          if (singleItem.single_weight_number) {
            form.setFieldsValue({ [`single_weight_number_${weightIdx}_${posIdx}_${dataIdx}`]: singleItem.single_weight_number });
          }
          if (singleItem.single_weight_pic && singleItem.single_weight_pic.length > 0) {
            form.setFieldsValue({ [`single_weight_pic_${weightIdx}_${posIdx}_${dataIdx}`]: singleItem.single_weight_pic });
          }
        });
      });
    });
    setInfo({ ...detail_info, ...info, id, quality_no, status, order_no });
    setFieldsValue({
      car_number_pic, driver_license_pic, box_in_humidity_pic, carton_condition_number_pic, carton_condition_number_video,
      container_temperature_head_pic, container_temperature_middle_pic, container_temperature_end_pic, core_temperature1_pic,
      core_temperature2_pic, core_temperature3_pic, IOT1_no_temperature_pic, IOT2_no_temperature_pic, IOT3_no_temperature_pic,
      shuck_other_fruit_pic, cleft_fruit_low_pic, cleft_fruit_middle_pic, cleft_fruit_high_pic, fruit_flesh_rot_pic, fruit_flesh_blight_pic,
      fruit_flesh_wormy_pic, flesh_color_pic,
      carton_packaging_sticker_pic, fruit_handle_sticker_pic, poor_fruit_shape_describe,
      container_no, arrival_time: moment(moment(arrival_time).format(formatType)), temperature, car_number, car_type, address_id, warehouse_name, warehouse_phone, finance_name, finance_phone,
      air_temperature, fruit_flesh_burning_pic, sugar_sampling1_pic, sugar_sampling2_pic, sugar_sampling3_pic,
      // container_time: moment(moment(container_time).format(formatType)),
      outlet_temperature, return_air_temperature, box_in_temperature, core_temperature, container_taste, container_taste_desc,
      sample_number, total_number,
      average_weight, package_weight, deviation, is_standard,
      poor_fruit_shape_number,
      fruit_color, colour_info_describe, red_thorn_fruit, brown_fruit, whole_green_fruit, other_fruit,
      bear_fruit, damage_fruit, wormhole_fruit, rotten_fruit, shuck_other_fruit, cleft_fruit, maturity, shuck_info_describe, bear_fruit_describe, dead_fruit_describe, durian_fruit_describe, damage_fruit_describe, dead_fruit_pic, durian_fruit_pic, dead_fruit, durian_fruit,
      sugar_sampling, sugar_sampling1, sugar_sampling2, sugar_sampling3, average_sugar, flesh_color, flesh_taste,
      inspection_pic, inspection_scene_pic, inspection_process_pic, inspection_process_video, inspection_card_video,
      inspection_video, inspection_scene_video,
      inspection_report,
      container_pic,
      outlet_temperature_pic,
      return_air_temperature_pic,
      air_temperature_pic,
      box_in_temperature_pic,
      core_temperature_pic,
      weight_pic,
      poor_fruit_shape_number_pic,
      hardness_fruit,
      hardness_fruit_video,
      bear_fruit_pic,
      damage_fruit_pic,
      cleft_fruit_pic,
      average_sugar_pic,
      hardness_flesh_video,
      hardness_flesh,
      buy_comments,
      quality_time: moment(moment(quality_time).format(formatType)),
      driver_license, driver_name, driver_number, warehouse_position, finance_position, sales_name, sales_phone, sales_position,
      box_in_humidity, carton_condition_type, carton_condition_number, container_temperature_head, container_temperature_middle, container_temperature_end,
      core_temperature1, core_temperature2, core_temperature3, IOT1_no, IOT2_no, IOT3_no, IOT1_no_temperature, IOT2_no_temperature, IOT3_no_temperature,
      poor_fruit_shape, fruit_house, fruit_house_number, fruit_house_number_3,
      fruit_house_number_35, fruit_house_number_4,
      fruit_house_shape_number_pic, fruit_house_number_3_pic, fruit_house_number_4_pic,
      fruit_color_1, fruit_color_1_pic, fruit_color_2, fruit_color_2_pic, fruit_color_3, fruit_color_3_pic, fruit_color_4, fruit_color_4_pic,
      fruit_peel_type, fruit_peel_number,
      bear_fruit_video, dead_fruit_video,
      fruit_shell_type, cleft_fruit_low, cleft_fruit_middle, cleft_fruit_high,
      fruit_shell_in_type, fruit_flesh_type, fruit_flesh_rot,
      fruit_flesh_wormy, fruit_flesh_burning,
      fruit_stalk_type, fruit_stalk_broken, fruit_stalk_broken_pic, fruit_stalk_lacking, fruit_stalk_lacking_pic, fruit_stalk_rotten, fruit_stalk_rotten_pic, fruit_stalk_number,
      sugar_sampling_type,
      fruit_flesh_blight,
      rotten_fruit_pic, wormhole_fruit_pic,
      ...number_options
    });
    computed_data_source(dataSource);
    // computed_sample_number_percent();
  };
  // 称重图片删除
  const weight_remove = (event, weightIdx, posIdx, dataIdx) => {
    event.stopPropagation();
    const newWeightData = [...weight_data];
    newWeightData[weightIdx].weight_source[posIdx].single_data[dataIdx].single_weight_pic = [];
    setWeightData(newWeightData);
    // 更新表单字段，确保表单知道照片已删除
    form.setFieldsValue({ [`single_weight_pic_${weightIdx}_${posIdx}_${dataIdx}`]: [] });
  };
  //称重图片上传
  const weight_change = async (currentFile, weightIdx, posIdx, dataIdx) => {
    try {
      const currentItem = await uploadBase(currentFile);
      const newWeightData = [...weight_data];
      newWeightData[weightIdx].weight_source[posIdx].single_data[dataIdx].single_weight_pic = [currentItem];
      setWeightData(newWeightData);
      // 更新表单字段，确保表单知道照片已上传
      form.setFieldsValue({ [`single_weight_pic_${weightIdx}_${posIdx}_${dataIdx}`]: [currentItem] });
    } catch (error) {
      message.error(`图片上传失败：${error.message}`);
    }
  };
  // 到货商品信息
  const pic_change = async (currentFile, type, item) => {
    try {
      const currentItem = await uploadBase(currentFile);
      const newInfo = {
        ...info,
        [item]: { ...info[item], [type]: [currentItem] }
      };
      setInfo(newInfo);
    } catch (error) {
      message.error(`图片上传失败：${error.message}`);
    }
  };
  const public_carton_remove = (event, type, item) => {
    event.stopPropagation();
    if (!info || !item || !type || !info[item]) {
      message.error('移除失败，数据异常！');
      return;
    }
    const newInfo = {
      ...info,
      [item]: { ...info[item], [type]: [] }
    };
    setFieldsValue({ [type]: [] });
    setInfo(newInfo);
    return false;
  };

  const outlet_temperature_pic_change = async (currentFile) => {
    const currentItem = await uploadBase(currentFile);
    info.container_info.outlet_temperature_pic = [currentItem];
    setInfo({ ...info });
  };
  const outlet_temperature_pic_remove = (event) => {
    event.stopPropagation();
    info.container_info.outlet_temperature_pic = [];
    setFieldsValue({ outlet_temperature_pic: [] });
    setInfo({ ...info });
    return false;
  };
  const return_air_temperature_pic_change = async (currentFile) => {
    const currentItem = await uploadBase(currentFile);
    info.container_info.return_air_temperature_pic = [currentItem];
    setInfo({ ...info });
  };
  const return_air_temperature_pic_remove = (event) => {
    event.stopPropagation();
    info.container_info.return_air_temperature_pic = [];
    setFieldsValue({ return_air_temperature_pic: [] });
    setInfo({ ...info });
    return false;
  };
  const air_temperature_pic_change = async (currentFile) => {
    const currentItem = await uploadBase(currentFile);
    info.container_info.air_temperature_pic = [currentItem];
    setInfo({ ...info });
  };
  const air_temperature_pic_remove = (event) => {
    event.stopPropagation();
    info.container_info.air_temperature_pic = [];
    setFieldsValue({ air_temperature_pic: [] });
    setInfo({ ...info });
    return false;
  };
  const carton_packaging_sticker_pic_change = async (currentFile) => {
    const currentItem = await uploadBase(currentFile);
    info.carton_packaging.carton_packaging_sticker_pic = [currentItem];
    setInfo({ ...info });
  };
  const carton_packaging_sticker_pic_remove = (event) => {
    event.stopPropagation();
    info.carton_packaging.carton_packaging_sticker_pic = [];
    setFieldsValue({ carton_packaging_sticker: [] });
    setInfo({ ...info });
    return false;
  };
  const fruit_handle_sticker_pic_change = async (currentFile) => {
    const currentItem = await uploadBase(currentFile);
    info.fruit_handle.fruit_handle_sticker_pic = [currentItem];
    setInfo({ ...info });
  };
  const fruit_handle_sticker_pic_remove = (event) => {
    event.stopPropagation();
    info.fruit_handle.fruit_handle_sticker_pic = [];
    setFieldsValue({ fruit_handle_sticker: [] });
    setInfo({ ...info });
    return false;
  };
  const poor_fruit_shape_number_pic_change = async (currentFile) => {
    const currentItem = await uploadBase(currentFile);
    info.fruit_shape.poor_fruit_shape_number_pic = [currentItem];
    setInfo({ ...info });
  };
  const poor_fruit_shape_number_pic_remove = (event) => {
    event.stopPropagation();
    info.fruit_shape.poor_fruit_shape_number_pic = [];
    setFieldsValue({ poor_fruit_shape_number_pic: [] });
    setInfo({ ...info });
    return false;
  };

  const inspection_video_change = async (currentFile) => {
    const currentItem = await uploadBase(currentFile);
    info.other_info.inspection_scene_video = [currentItem];
    setInfo({ ...info });
  };
  const inspection_video_remove = (event) => {
    event.stopPropagation();
    info.other_info.inspection_scene_video = [];
    setInfo({ ...info });
    return false;
  };

  const inspection_pic_change = async (currentFile) => {
    const currentItem = await uploadBase(currentFile);
    const list = [...info.other_info.inspection_pic, currentItem];
    info.other_info.inspection_pic = list.length > 3 ? list.slice(list.length - 3) : list;
    setInfo({ ...info });
  };
  const inspection_pic_remove = (event, currentIndex) => {
    event.stopPropagation();
    info.other_info.inspection_pic = info.other_info.inspection_pic.filter((item, index) => index !== +currentIndex);
    setFieldsValue({ inspection_pic: info.other_info.inspection_pic || [] });
    setInfo({ ...info });
    return info.other_info.inspection_pic < 1;
  };
  const inspection_process_change = async (currentFile) => {
    const currentItem = await uploadBase(currentFile);
    const list = [...info.other_info.inspection_process_pic, currentItem];
    info.other_info.inspection_process_pic = list.length > 3 ? list.slice(list.length - 3) : list;
    setInfo({ ...info });
  };
  const inspection_process_remove = (event, currentIndex) => {
    event.stopPropagation();
    info.other_info.inspection_process_pic = info.other_info.inspection_process_pic.filter((item, index) => index !== +currentIndex);
    setFieldsValue({ inspection_process_pic: info.other_info.inspection_process_pic || [] });
    setInfo({ ...info });
    return info.other_info.inspection_process_pic < 1;
  };
  const inspection_scene_change = async (currentFile) => {
    const currentItem = await uploadBase(currentFile);
    const list = [...info.other_info.inspection_scene_pic, currentItem];
    info.other_info.inspection_scene_pic = list.length > 3 ? list.slice(list.length - 3) : list;
    setInfo({ ...info });
  };
  const inspection_scene_remove = (event, currentIndex) => {
    event.stopPropagation();
    info.other_info.inspection_scene_pic = info.other_info.inspection_scene_pic.filter((item, index) => index !== +currentIndex);
    setFieldsValue({ inspection_scene_pic: info.other_info.inspection_scene_pic || [] });
    setInfo({ ...info });
    return info.other_info.inspection_scene_pic < 1;
  };
  const getAudioDuration = (file) => {
    return new Promise(resolve => {
      const url = URL.createObjectURL(file);
      const audioElement = new Audio(url);
      audioElement.addEventListener("loadedmetadata", () => {
        resolve(audioElement.duration);
      });
    });
  };
  const inspection_video_before_upload = async (file) => {
    const { type } = file;
    const isLimitTime = (await getAudioDuration(file)) <= 60;
    const isMp4 = type === 'video/mp4';
    if (!isMp4) {
      message.error('请上传mp4格式的质检现场视频!');
    }
    if (!isLimitTime) {
      message.error('请上传质检现场视频时长不超过60s!');
    }
    return isMp4 && isLimitTime;
  };

  const showModal = (options = {}) => {
    setCurrentOptions(options);
    setModalVisible(true);
  };
  const handleOk = () => {
    setModalVisible(false);
  };
  const handleCancel = () => {
    setModalVisible(false);
  };
  const formatFormValues = () => {
    const form_data = getFieldsValue();
    const {
      container_no, arrival_time, temperature, car_number, car_type, address_id, warehouse_name, warehouse_phone, finance_name, finance_phone,
      // container_time: containerTime, 
      air_temperature,
      outlet_temperature, return_air_temperature, box_in_temperature, core_temperature, container_taste, container_taste_desc,
      sample_number, total_number,
      average_weight, package_weight, deviation, is_standard,
      poor_fruit_shape_number,
      fruit_color, colour_info_describe, red_thorn_fruit, brown_fruit, whole_green_fruit, other_fruit,
      bear_fruit, damage_fruit, wormhole_fruit, rotten_fruit, shuck_other_fruit, cleft_fruit, maturity, shuck_info_describe, hardness_fruit, bear_fruit_describe, dead_fruit, dead_fruit_describe, durian_fruit, durian_fruit_describe, damage_fruit_describe,
      sugar_sampling, average_sugar, flesh_color, flesh_taste, hardness_flesh,
      buy_comments, poor_fruit_shape_describe, poor_fruit_shape,
      quality_time, driver_license, driver_name, driver_number, warehouse_position, finance_position, sales_name, sales_phone, sales_position,
      box_in_humidity, carton_condition_type, carton_condition_number, container_temperature_head, container_temperature_middle, container_temperature_end, core_temperature1, core_temperature2, core_temperature3, IOT1_no, IOT1_no_temperature, IOT2_no, IOT2_no_temperature,
      IOT3_no, IOT3_no_temperature, fruit_house, fruit_house_number, fruit_house_number_3, fruit_house_number_35, fruit_house_number_4, fruit_shell_type, cleft_fruit_low, cleft_fruit_middle, cleft_fruit_high,
      fruit_shell_in_type, fruit_flesh_type, fruit_flesh_rot, fruit_flesh_blight, sugar_sampling_type, sugar_sampling1, sugar_sampling2, sugar_sampling3, fruit_flesh_wormy, fruit_flesh_burning,
      fruit_stalk_type, fruit_stalk_broken, fruit_stalk_lacking, fruit_stalk_rotten, fruit_stalk_number, fruit_color_1, fruit_color_2, fruit_color_3, fruit_color_4, fruit_peel_type, fruit_peel_number,
    } = form_data;
    const { container_info = {}, weight_info = {}, fruit_shape = {}, shuck_info = {}, flesh_info = {}, other_info = {}, carton_packaging = {}, fruit_handle = {}, base_info = {}, fruit_stalk = {}, colour_info = {} } = info;
    const { container_pic = [], outlet_temperature_pic = [], return_air_temperature_pic = [], core_temperature_pic = [], air_temperature_pic = [], box_in_temperature_pic = [], carton_condition_number_pic = [], carton_condition_number_video = [],
      container_temperature_head_pic = [], container_temperature_middle_pic = [], container_temperature_end_pic = [], core_temperature1_pic = [], core_temperature2_pic = [], core_temperature3_pic = [], IOT1_no_temperature_pic = [], IOT2_no_temperature_pic = [], IOT3_no_temperature_pic = [],
      box_in_humidity_pic = [] } = container_info;
    const { weight_pic = [] } = weight_info;
    const { poor_fruit_shape_number_pic = [], fruit_house_shape_number_pic = [], fruit_house_number_3_pic = [], fruit_house_number_35_pic = [], fruit_house_number_4_pic = [] } = fruit_shape;
    const { bear_fruit_pic = [], damage_fruit_pic = [], cleft_fruit_pic = [], hardness_fruit_video = [], dead_fruit_pic = [], durian_fruit_pic = [], bear_fruit_video = [], dead_fruit_video = [], shuck_other_fruit_pic = [], cleft_fruit_low_pic = [], cleft_fruit_middle_pic = [],
      cleft_fruit_high_pic = [], fruit_flesh_rot_pic = [], fruit_flesh_blight_pic = [], fruit_flesh_wormy_pic = [], fruit_flesh_burning_pic = [], wormhole_fruit_pic = [], rotten_fruit_pic = [], } = shuck_info;
    const { average_sugar_pic = [], hardness_flesh_video = [], sugar_sampling1_pic = [], sugar_sampling2_pic = [], sugar_sampling3_pic = [], flesh_color_pic = [] } = flesh_info;
    const { inspection_pic = [], inspection_video = [], inspection_report = [], inspection_scene_pic = [], inspection_process_pic = [], inspection_process_video = [], inspection_card_video = [], inspection_scene_video = [] } = other_info;
    const address = (qualityBaseInfo?.address_list || []).find(item => String(item.id) === String(address_id));
    // const container_time = containerTime.format(formatType);
    const { carton_packaging_sticker_pic = [] } = carton_packaging;
    const { fruit_handle_sticker_pic = [] } = fruit_handle;
    const { car_number_pic = [], driver_license_pic = [] } = base_info;
    const { fruit_stalk_broken_pic = [], fruit_stalk_lacking_pic = [], fruit_stalk_rotten_pic = [], } = fruit_stalk;
    const { fruit_color_1_pic = [], fruit_color_2_pic = [], fruit_color_3_pic = [], fruit_color_4_pic = [] } = colour_info;
    return {
      order_no: order_id,
      quality_no: quality_id,
      status: 1,
      base_info: {
        container_no: container_no?.split("-")[0], arrival_time, temperature, car_number, car_type, address_id, warehouse_name, warehouse_phone, finance_name, finance_phone, address, quality_time,
        driver_license, driver_license_pic, driver_name, driver_number, warehouse_position, finance_position, sales_name, sales_phone, sales_position, car_number_pic,
      },
      product_info: dataSource,
      container_info: {
        air_temperature,
        outlet_temperature, return_air_temperature, box_in_temperature, core_temperature, container_pic, container_taste, container_taste_desc, outlet_temperature_pic, return_air_temperature_pic, box_in_temperature_pic, core_temperature_pic, air_temperature_pic,
        carton_condition_number_pic, carton_condition_number_video, container_temperature_head_pic, container_temperature_middle_pic, container_temperature_end_pic, core_temperature1_pic, core_temperature2_pic, core_temperature3_pic, IOT1_no_temperature_pic,
        IOT2_no_temperature_pic, IOT3_no_temperature_pic, box_in_humidity, box_in_humidity_pic, container_temperature_head, container_temperature_middle, container_temperature_end, core_temperature1, core_temperature2, core_temperature3, IOT1_no, IOT1_no_temperature, IOT2_no, IOT2_no_temperature,
        IOT3_no, IOT3_no_temperature, carton_condition_type, carton_condition_number,
      },
      sample_info: { sample_number, total_number, },
      weight_info: { weight_pic, average_weight, package_weight, deviation, is_standard, },
      fruit_shape: { poor_fruit_shape, poor_fruit_shape_number, poor_fruit_shape_number_pic, poor_fruit_shape_describe, fruit_house, fruit_house_number, fruit_house_shape_number_pic, fruit_house_number_3, fruit_house_number_3_pic, fruit_house_number_35, fruit_house_number_35_pic, fruit_house_number_4, fruit_house_number_4_pic },
      colour_info: { fruit_color, colour_info_describe, red_thorn_fruit, brown_fruit, whole_green_fruit, other_fruit, fruit_color_1, fruit_color_1_pic, fruit_color_2, fruit_color_2_pic, fruit_color_3, fruit_color_3_pic, fruit_color_4, fruit_color_4_pic, fruit_peel_type, fruit_peel_number },
      shuck_info: {
        bear_fruit, damage_fruit, wormhole_fruit, rotten_fruit, shuck_other_fruit, cleft_fruit, maturity, shuck_info_describe, bear_fruit_pic, damage_fruit_pic, cleft_fruit_pic, hardness_fruit, hardness_fruit_video, bear_fruit_describe, dead_fruit, dead_fruit_describe, durian_fruit, durian_fruit_describe, damage_fruit_describe, dead_fruit_pic, durian_fruit_pic,
        bear_fruit_video, dead_fruit_video, fruit_shell_type, shuck_other_fruit_pic, cleft_fruit_low, cleft_fruit_low_pic, cleft_fruit_middle, cleft_fruit_middle_pic, cleft_fruit_high, cleft_fruit_high_pic, fruit_shell_in_type, fruit_flesh_type, fruit_flesh_rot, fruit_flesh_rot_pic, fruit_flesh_blight, fruit_flesh_blight_pic, fruit_flesh_wormy, fruit_flesh_wormy_pic, fruit_flesh_burning, fruit_flesh_burning_pic,
        wormhole_fruit_pic, rotten_fruit_pic
      },
      flesh_info: { sugar_sampling, average_sugar, flesh_color, average_sugar_pic, hardness_flesh_video, hardness_flesh, sugar_sampling_type, flesh_taste, sugar_sampling1, sugar_sampling2, sugar_sampling3, sugar_sampling1_pic, sugar_sampling2_pic, sugar_sampling3_pic, flesh_color_pic },
      other_info: { inspection_pic, inspection_video, inspection_report, inspection_scene_pic, inspection_process_pic, inspection_process_video, inspection_card_video, inspection_scene_video },
      buy_comments,
      carton_packaging: { carton_packaging_sticker_pic }, //纸箱包装贴纸
      fruit_handle: { fruit_handle_sticker_pic }, //果把贴码
      fruit_stalk: { fruit_stalk_type, fruit_stalk_broken, fruit_stalk_broken_pic, fruit_stalk_lacking, fruit_stalk_lacking_pic, fruit_stalk_rotten, fruit_stalk_rotten_pic, fruit_stalk_number }//果柄
    };
  };
  const draft = () => {
    save(1);
  };
  const save = async (status = 1) => {
    const { id } = info;
    const base_data = formatFormValues();
    const { base_info: { container_no } } = base_data;
    if (container_no) {
      const finally_data = { ...base_data, id, status, weight_data };
      const { data: { code, msg, data: { id: sid, quality_no } } } = await createQuality(finally_data);
      if (+code === 0) {
        message.success(`${status === 1 ? '保存' : '提交'}成功！`, () => {
          if (+status === 1) {
            setInfo({ ...info, id: sid, quality_no });
          } else if (status === 2) {
            history.goBack();
          }
        });
      } else {
        message.error(msg);
      }
    } else {
      message.error('请填写柜号!');
    }
  };
  const cancel = () => {
    history.goBack();
  };

  return (
    <div className='quality-report-container'>
      <Space className='mb-20' split={<RightOutlined />}>
        <Link to={{ pathname: '/basic/user/order' }}>我的采购单</Link>
        <span>订单号：{order_id}</span>
        <span>质检记录</span>
      </Space>
      {
        loading ? <>
          <div className='port-quality-report-base'>
            <div onClick={() => { setPdfVisible(true); }} style={{ color: '#D60505', cursor: 'pointer' }}> <SoundOutlined />请在质检前详细阅读质检要求，点击查看详情</div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div className='quality-report-title'>到货基本信息</div>
              <Modal open={pdfVisible} onOk={() => setPdfVisible(false)} onCancel={() => { setPdfVisible(false); }} footer={null} centered width={800} style={{ height: '800px' }}>
                <div style={{ width: '100%', height: '950px' }}>
                  <object
                    style={{ width: '100%', height: '100%', border: 'none' }}
                    data={testPdf}
                    type="application/pdf"
                    typemustmatch
                  >
                  </object>
                </div>
              </Modal>
              {+type > 1 ? <Button type='primary' onClick={() => { history.push(`/warehouseQualityPrint/${order_id}/${type}/${quality_id}?print=true`); }}>导出</Button> : null}
            </div>
            <Form
              name="basic"
              {...formItemLayout}
              form={form}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
              className='quality-form'
              initialValues={{ standard_weight: standardWeight }}
            >
              <Row gutter={8}>
                <Col span={7}>
                  <Form.Item size='small' colon={false} label="柜号" name="container_no" rules={[{ required: true, message: '请选择柜号!', },]}>
                    <Select disabled={!canEdit}>{(qualityBaseInfo?.container_no || []).map(item => <Option key={item} value={item}>{item}</Option>)}</Select>
                  </Form.Item>
                </Col>
                <Col span={7}>
                  <Form.Item size='small' colon={false} label="到货时间" name="arrival_time" rules={[{ required: true, message: '请选择到货时间!', },]}>
                    <DatePicker disabled={!canEdit} format={formatType} showTime />
                  </Form.Item>
                </Col>
                <Col span={7}>
                  <Form.Item size='small' colon={false} label="质检时间" name="quality_time" rules={[{ required: true, message: '请选择质检时间!', },]}>
                    <DatePicker disabled={!canEdit} format={formatType} showTime />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={7}>
                  <Form.Item size='small' colon={false} label="汽车车牌号" name="car_number" rules={[{ required: true, message: '请填写汽车车牌号!', },]}>
                    <Input disabled={!canEdit} />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item size='small' colon={false} name="car_number_pic" rules={[{ required: true, message: '请上传图片!', },]}>
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      fileList={(info?.base_info?.car_number_pic || [])}
                      customRequest={(file) => pic_change(file, 'car_number_pic', 'base_info')}
                      accept="image/png, image/jpeg"
                      maxCount={1}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {(info?.base_info?.car_number_pic || []).length ? '' : <Button icon={<UploadOutlined />}>上传图片</Button>}
                      </div>
                    </Upload>
                  </Form.Item>
                </Col>
                <Col span={7}>
                  <Form.Item size='small' colon={false} label="汽车车型" name="car_type" rules={[{ required: true, message: '请填写汽车车型!', },]}>
                    <Input disabled={!canEdit} />
                  </Form.Item>
                </Col>
              </Row>
              <Index list={info?.base_info?.car_number_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'car_number_pic', 'container_info')} />
              <Row>
                <Col span={7}>
                  <Form.Item size='small' colon={false} label="驾驶证" name="driver_license" rules={[{ required: true, message: '请填写驾驶证!', },]}>
                    <Input disabled={!canEdit} />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item size='small' colon={false} name="driver_license_pic" rules={[{ required: true, message: '请上传驾驶证图片!', },]}>
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      fileList={(info?.base_info?.driver_license_pic || [])}
                      customRequest={(file) => pic_change(file, 'driver_license_pic', 'base_info')}
                      accept="image/png, image/jpeg"
                      maxCount={1}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {(info?.base_info?.driver_license_pic || []).length ? '' : <Button icon={<UploadOutlined />}>上传图片</Button>}
                      </div>
                    </Upload>
                  </Form.Item>
                </Col>
                <Col span={7}>
                  <Form.Item size='small' colon={false} label="驾驶员姓名" name="driver_name" rules={[{ required: true, message: '请填写驾驶员姓名!', },]}>
                    <Input disabled={!canEdit} />
                  </Form.Item>
                </Col>
                <Col span={7}>
                  <Form.Item size='small' colon={false} label="驾驶员电话" name="driver_number" rules={[{ required: true, message: '请填写驾驶电话!', },]}>
                    <Input disabled={!canEdit} />
                  </Form.Item>
                </Col>
              </Row>
              <Index list={info?.base_info?.driver_license_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'driver_license_pic', 'container_info')} />
              <Row>
                <Col span={16}>
                  <Form.Item size='small' colon={false} labelCol={{ span: 3 }} label="到货地" name="address_id" rules={[{ required: true, message: '请选择到货地!', },]} >
                    <Select disabled={!canEdit}>{(qualityBaseInfo?.address_list || []).map(item => <Option key={item.id} value={item.id}>{item.address}</Option>)}</Select>
                  </Form.Item>
                </Col>
                <Col span={7}>
                  <Form.Item size='small' colon={false} label="环境温度" required wrapperCol={{ span: 12 }}>
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="temperature" noStyle rules={[{ required: true, message: '请填写环境温度!', },]}>
                        <InputNumber disabled={!canEdit} controls={false} precision={1} />
                      </Form.Item>
                      <span>℃</span>
                    </div>
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col><Form.Item size='small' colon={false} label='质检人员' labelCol={{ span: 24 }}></Form.Item></Col>
                <Col span={7}><Form.Item size='small' colon={false} label='姓名' name="warehouse_name" rules={[{ required: true, message: '请填写质检姓名!', },]}>
                  <Input disabled={!canEdit} maxLength={40} />
                </Form.Item></Col>
                <Col span={7}><Form.Item size='small' colon={false} label='电话' name="warehouse_phone" rules={[{ required: true, message: '请填写质检电话!', },]}>
                  <Input disabled={!canEdit} controls={false} maxLength={40} onChange={(e) => {
                    const value = String(e.target.value).replace(/[^0-9]/ig, '');
                    setFieldsValue({ warehouse_phone: isPureNumber(value) ? Math.abs(value) : '' });
                  }} /></Form.Item>
                </Col>
                <Col span={7}><Form.Item size='small' colon={false} label='职位' name="warehouse_position" rules={[{ required: true, message: '请填写质检职位!', },]}>
                  <Input disabled={!canEdit} maxLength={40} />
                </Form.Item></Col>
              </Row>
              <Row>
                <Col><Form.Item size='small' colon={false} label='财务人员' labelCol={{ span: 24 }}></Form.Item></Col>
                <Col span={6}><Form.Item size='small' colon={false} label='姓名' name="finance_name" rules={[{ required: true, message: '请填写财务人员姓名!', },]}>
                  <Input disabled={!canEdit} maxLength={40} />
                </Form.Item></Col>
                <Col span={7}><Form.Item size='small' colon={false} label='电话' name="finance_phone" rules={[{ required: true, message: '请填写财务人员电话!', },]}>
                  <Input disabled={!canEdit} controls={false} maxLength={40} onChange={e => {
                    const value = String(e.target.value).replace(/[^0-9]/ig, '');
                    setFieldsValue({ finance_phone: isPureNumber(value) ? Math.abs(value) : '' });
                  }} />
                </Form.Item></Col>
                <Col span={7}><Form.Item size='small' colon={false} label='职位' name="finance_position" rules={[{ required: true, message: '请填写财务人员职位!', },]}>
                  <Input disabled={!canEdit} maxLength={40} />
                </Form.Item></Col>
              </Row>
              <Row>
                <Col><Form.Item size='small' colon={false} label='销售代表' labelCol={{ span: 24 }}></Form.Item></Col>
                <Col span={6}><Form.Item size='small' colon={false} label='姓名' name="sales_name" rules={[{ required: true, message: '请填写销售代表姓名!', },]}>
                  <Input disabled={!canEdit} maxLength={40} />
                </Form.Item></Col>
                <Col span={7}><Form.Item size='small' colon={false} label='电话' name="sales_phone" rules={[{ required: true, message: '请填写销售代表电话!', },]}>
                  <Input disabled={!canEdit} controls={false} maxLength={40} onChange={e => {
                    const value = String(e.target.value).replace(/[^0-9]/ig, '');
                    setFieldsValue({ sales_phone: isPureNumber(value) ? Math.abs(value) : '' });
                  }} />
                </Form.Item></Col>
                <Col span={7}><Form.Item size='small' colon={false} label='职位' name="sales_position" rules={[{ required: true, message: '请填写销售代表职位!', },]}>
                  <Input disabled={!canEdit} maxLength={40} />
                </Form.Item></Col>
              </Row>
              <div className='quality-report-title'>到货商品信息</div>
              <Table
                className='quality-table'
                bordered
                dataSource={dataSource}
                columns={columns}
                pagination={false}
                rowKey='sale_id'
                summary={() => {
                  const { standard_numbers_check, standard_numbers, actual_numbers, actual_numbers_check } = computedSource;
                  return (
                    <>
                      <Table.Summary.Row>
                        <Table.Summary.Cell index={0}>合计</Table.Summary.Cell>
                        <Table.Summary.Cell index={4}></Table.Summary.Cell>
                        <Table.Summary.Cell index={1}>{standard_numbers_check ? standard_numbers + '箱' : ''}</Table.Summary.Cell>
                        <Table.Summary.Cell index={2}></Table.Summary.Cell>
                        <Table.Summary.Cell index={3}>{actual_numbers_check ? actual_numbers + '箱' : ''}</Table.Summary.Cell>
                        <Table.Summary.Cell index={4}></Table.Summary.Cell>
                        <Table.Summary.Cell index={5}>{computedSource?.deviation}</Table.Summary.Cell>
                      </Table.Summary.Row>
                    </>
                  );
                }}
              />
              <Row style={{ marginTop: 20 }}>
                <Col span={10}>
                  <Form.Item size='small' colon={false} label="集装箱内部湿度" required labelCol={{ span: 8 }} wrapperCol={{ span: 8 }} >
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="box_in_humidity" noStyle rules={[{ required: true, message: '请填写湿度!' }]}>
                        <InputNumber disabled={!canEdit} controls={false} precision={2} />
                      </Form.Item>
                      <span>%</span>
                      {humidity_level && <Tag color={humidity_color} size="small">{humidity_level}</Tag>}
                    </div>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item size='small' name="box_in_humidity_pic" rules={[{ required: true, message: '请上传集装箱内部湿度照片' }]}>
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      customRequest={(file) => pic_change(file, 'box_in_humidity_pic', 'container_info')}
                      accept="image/png, image/jpeg"
                      fileList={(info?.container_info?.box_in_humidity_pic || [])}
                      multiple
                      maxCount={1}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {((info?.container_info?.box_in_humidity_pic || []).length) ? '' : <><Button icon={<UploadOutlined />}>上传图片</Button></>}
                      </div>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
              <Index list={info?.container_info?.box_in_humidity_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'box_in_humidity_pic', 'container_info')} />
              <Row>
                <Col span={6}>
                  <Form.Item size='small' colon={false} label="纸箱状况" name="carton_condition_type" rules={[{ required: true, message: '请选择纸箱状况!' }]}>
                    <Select disabled={!canEdit}>{['潮湿', '干燥'].map(item => <Option key={item} value={item}>{item}</Option>)}</Select>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item size='small' colon={false} label="数量" required={carton_condition_type_required} rules={[{ required: carton_condition_type_required, message: '请填写数量!' }]}>
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="carton_condition_number" noStyle rules={[{ required: carton_condition_type_required, message: '请填写数量!', },]}>
                        <InputNumber disabled={!canEdit} controls={false} min={1} precision={0} />
                      </Form.Item>
                      <span>箱</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item size='small' colon={false} name="carton_condition_number_pic" label='' rules={[{ required: carton_condition_type_required, message: '请上传图片!' }]}>
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      fileList={(info?.container_info?.carton_condition_number_pic || [])}
                      customRequest={(file) => pic_change(file, 'carton_condition_number_pic', 'container_info')}
                      accept="image/png, image/jpeg"
                      maxCount={1}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {(info?.container_info?.carton_condition_number_pic || []).length ? '' : <Button icon={<UploadOutlined />}>上传图片</Button>}
                      </div>
                    </Upload>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item size='small' colon={false} name="carton_condition_number_video" label='' rules={[{ required: carton_condition_type_required, message: '请上传视频!' }]}>
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      fileList={(info?.container_info?.carton_condition_number_video || [])}
                      customRequest={(file) => pic_change(file, 'carton_condition_number_video', 'container_info')}
                      accept="video/mp4"
                      maxCount={1}
                      disabled={!canEdit}
                      beforeUpload={validateVideoBeforeUpload}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {(info?.container_info?.carton_condition_number_video || []).length ? '' : <Button icon={<UploadOutlined />}>上传视频</Button>}
                      </div>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
              <Index list={info?.container_info?.carton_condition_number_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'carton_condition_number_pic', 'container_info')} />
              <Index list={info?.container_info?.carton_condition_number_video || []} type='video' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'carton_condition_number_video', 'container_info')} />
              <Row>
                <Col span={8}>
                  <Form.Item size='small' colon={false} label="纸箱包装贴纸" name="carton_packaging_sticker_pic" rules={[{ required: true, message: '请上传纸箱包装贴纸图片!' }]}>
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      customRequest={(file) => carton_packaging_sticker_pic_change(file)}
                      accept="image/png, image/jpeg"
                      fileList={(info?.carton_packaging?.carton_packaging_sticker_pic || [])}
                      multiple
                      maxCount={1}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {(info?.carton_packaging?.carton_packaging_sticker_pic || []).length ? '' : <><Button icon={<UploadOutlined />}>上传图片</Button></>}
                      </div>
                    </Upload>
                  </Form.Item>
                  <Index list={info?.carton_packaging?.carton_packaging_sticker_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={carton_packaging_sticker_pic_remove} />
                </Col>
                <Col offset={8} span={8}>
                  <Form.Item size='small' colon={false} label="果把贴码" name="fruit_handle_sticker_pic" rules={[{ required: true, message: '请上传果把贴码图片!', }]}>
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      customRequest={(file) => fruit_handle_sticker_pic_change(file)}
                      accept="image/png, image/jpeg"
                      fileList={(info?.fruit_handle?.fruit_handle_sticker_pic || [])}
                      multiple
                      maxCount={1}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {(info?.fruit_handle?.fruit_handle_sticker_pic || []).length ? '' : <><Button icon={<UploadOutlined />}>上传图片</Button></>}
                      </div>
                      <span className='upload-span'>必须清晰可见编号</span>
                    </Upload>
                  </Form.Item>
                  <Index list={info?.fruit_handle?.fruit_handle_sticker_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={fruit_handle_sticker_pic_remove} />
                </Col>
              </Row>
              <div className='quality-report-title'>到货开柜</div>
              <Row>
                <Col span={24}><InfoCircleOutlined /><span style={{ color: 'D60505' }}>对于大型卡车，以集装箱仪器显示的设置温度、出风温度和回风温度为准。</span></Col>
                <Col span={24}><span style={{ color: 'D60505' }}>对于小型卡车，以车辆显示的设置温度作为设置温度和出风温度处，制冷装置(冷机显示屏)上显示的温度为回风温度。</span></Col>
                {/* <Col span={8}>
                  <Form.Item size='small' colon={false} label="开柜时间" name="container_time" rules={[{ required: true, message: '请选择开柜时间!', },]}>
                    <DatePicker disabled={!canEdit} format={formatType} showTime />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item size='small' colon={false} name="container_pic" rules={[{ required: true, message: '请上传开柜图片!', },]}>
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      fileList={(info?.container_info?.container_pic || [])}
                      customRequest={(file) => container_pic_change(file)}
                      accept="image/png, image/jpeg"
                      maxCount={1}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {(info?.container_info?.container_pic || []).length ? '' : <Button icon={<UploadOutlined />}>上传图片</Button>}
                      </div>
                    </Upload>
                  </Form.Item>
                </Col> */}
              </Row>
              {/* <Index list={info?.container_info?.container_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={container_pic_remove} /> */}
              <Row>
                <Col span={8}>
                  <Form.Item size='small' colon={false} label="出风温度" required>
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="outlet_temperature" noStyle rules={[{ required: true, message: '请填写出风温度!', },]}>
                        <InputNumber disabled={!canEdit} controls={false} precision={1} />
                      </Form.Item>
                      <span>℃</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item size='small' name="outlet_temperature_pic" rules={[{ required: true, message: '请上传出风温度图片!' }]}>
                    <Upload
                      name="file"
                      showUploadList={false}
                      fileList={(info?.container_info?.outlet_temperature_pic || [])}
                      customRequest={(file) => outlet_temperature_pic_change(file)}
                      accept="image/png, image/jpeg"
                      headers={{ token: localStorage.getItem('token') }}
                      maxCount={1}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {(info?.container_info?.outlet_temperature_pic || []).length ? '' : <Button icon={<UploadOutlined />}>上传图片</Button>}
                      </div>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
              <Index list={info?.container_info?.outlet_temperature_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={outlet_temperature_pic_remove} />
              <Row>
                <Col span={8}>
                  <Form.Item size='small' colon={false} label="回风温度" required>
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="return_air_temperature" noStyle rules={[{ required: true, message: '请填写回风温度!' }]}>
                        <InputNumber disabled={!canEdit} controls={false} precision={1} />
                      </Form.Item>
                      <span>℃</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item size='small' name="return_air_temperature_pic" rules={[{ required: true, message: '请上传回风温度图片!' }]}>
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      customRequest={(file) => return_air_temperature_pic_change(file)}
                      accept="image/png, image/jpeg"
                      fileList={(info?.container_info?.return_air_temperature_pic || [])}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {(info?.container_info?.return_air_temperature_pic || []).length ? '' : <Button icon={<UploadOutlined />}>上传图片</Button>}
                      </div>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
              <Index list={info?.container_info?.return_air_temperature_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={return_air_temperature_pic_remove} />
              <Row>
                <Col span={8}>
                  <Form.Item size='small' colon={false} label="风口" required>
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="air_temperature" noStyle rules={[{ required: true, message: '请填写风口!' }]}>
                        <InputNumber disabled={!canEdit} controls={false} precision={1} />
                      </Form.Item>
                      <span>%</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item size='small' colon={false} name="air_temperature_pic" rules={[{ required: false, message: '请上传风口图片!' }]}>
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      customRequest={(file) => air_temperature_pic_change(file)}
                      accept="image/png, image/jpeg"
                      fileList={(info?.container_info?.air_temperature_pic || [])}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {(info?.container_info?.air_temperature_pic || []).length ? '' : <Button icon={<UploadOutlined />}>上传图片</Button>}
                      </div>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
              <Index list={info?.container_info?.air_temperature_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={air_temperature_pic_remove} />
              {/* <Row>
                <Col span={8}>
                  <Form.Item size='small' colon={false} label="箱内温度" required>
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="box_in_temperature" noStyle rules={[{ required: true, message: '请填写出箱内温度!', },]}>
                        <InputNumber disabled={!canEdit} controls={false} precision={1} />
                      </Form.Item>
                      <span>℃</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={10}>
                  <Form.Item size='small' name="box_in_temperature_pic" rules={[{ required: true, message: '请上传柜头、中、尾各传2张!', }, { validator }]}>
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      customRequest={(file) => box_in_temperature_pic_change(file)}
                      accept="image/png, image/jpeg"
                      fileList={(info?.container_info?.box_in_temperature_pic || [])}
                      multiple
                      maxCount={6}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {((info?.container_info?.box_in_temperature_pic || []).length < 6) && <><Button icon={<UploadOutlined />}>上传图片</Button><span className='upload-span'>柜头、中、尾各传2张</span></>}
                      </div>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row> */}
              {/* <Index list={info?.container_info?.box_in_temperature_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={box_in_temperature_pic_remove} /> */}
              <Row><Col span={24}><span>测量 3 个柜内温度（前部、中部、尾部采样于卸货处）：</span></Col></Row>
              <Row>
                <Col span={8}>
                  <Form.Item size='small' colon={false} label="柜头" required>
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="container_temperature_head" noStyle rules={[{ required: true, message: '请填写柜头温度!' }]}>
                        <InputNumber disabled={!canEdit} controls={false} precision={1} />
                      </Form.Item>
                      <span>℃</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item size='small' name="container_temperature_head_pic" rules={[{ required: true, message: '请上传柜头照片!', }]}>
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      customRequest={(file) => pic_change(file, 'container_temperature_head_pic', 'container_info')}
                      accept="image/png, image/jpeg"
                      fileList={(info?.container_info?.container_temperature_head_pic || [])}
                      multiple
                      maxCount={1}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {((info?.container_info?.container_temperature_head_pic || []).length) ? '' : <><Button icon={<UploadOutlined />}>上传图片</Button></>}
                      </div>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
              <Index list={info?.container_info?.container_temperature_head_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'container_temperature_head_pic', 'container_info')} />
              <Row>
                <Col span={8}>
                  <Form.Item size='small' colon={false} label="柜中" required>
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="container_temperature_middle" noStyle rules={[{ required: true, message: '请填写柜中温度!' }]}>
                        <InputNumber disabled={!canEdit} controls={false} precision={1} />
                      </Form.Item>
                      <span>℃</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item size='small' name="container_temperature_middle_pic" rules={[{ required: true, message: '请上传柜中照片!' }]}>
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      customRequest={(file) => pic_change(file, 'container_temperature_middle_pic', 'container_info')}
                      accept="image/png, image/jpeg"
                      fileList={(info?.container_info?.container_temperature_middle_pic || [])}
                      multiple
                      maxCount={1}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {((info?.container_info?.container_temperature_middle_pic || []).length) ? '' : <><Button icon={<UploadOutlined />}>上传图片</Button></>}
                      </div>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
              <Index list={info?.container_info?.container_temperature_middle_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'container_temperature_middle_pic', 'container_info')} />
              <Row>
                <Col span={8}>
                  <Form.Item size='small' colon={false} label="柜尾" required>
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="container_temperature_end" noStyle rules={[{ required: true, message: '请填写柜尾温度!', },]}>
                        <InputNumber disabled={!canEdit} controls={false} precision={1} />
                      </Form.Item>
                      <span>℃</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item size='small' name="container_temperature_end_pic" rules={[{ required: true, message: '请上传柜尾照片!' }]}>
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      customRequest={(file) => pic_change(file, 'container_temperature_end_pic', 'container_info')}
                      accept="image/png, image/jpeg"
                      fileList={(info?.container_info?.container_temperature_end_pic || [])}
                      multiple
                      maxCount={6}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {((info?.container_info?.container_temperature_end_pic || []).length) ? '' : <><Button icon={<UploadOutlined />}>上传图片</Button></>}
                      </div>
                    </Upload>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item size='small' colon={false} label="平均温度">
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="container_temperature_average" noStyle>
                        <InputNumber disabled controls={false} precision={1} />
                      </Form.Item>
                      <span>℃</span>
                    </div>
                  </Form.Item>
                </Col>
              </Row>
              <Index list={info?.container_info?.container_temperature_end_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'container_temperature_end_pic', 'container_info')} />
              <Row><Col span={24}><span>测量 3 个果肉心温度（请注意尽量使用运输过程中测量的果实，以避免损坏更多果实）：</span></Col></Row>
              <Row>
                <Col span={8}>
                  <Form.Item size='small' colon={false} label="果心1" required>
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="core_temperature1" noStyle rules={[{ required: true, message: '请填写果心1温度!', },]}>
                        <InputNumber disabled={!canEdit} controls={false} precision={1} />
                      </Form.Item>
                      <span>℃</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item size='small' name="core_temperature1_pic" rules={[{ required: true, message: '请上传果心1照片!', }]}>
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      customRequest={(file) => pic_change(file, 'core_temperature1_pic', 'container_info')}
                      accept="image/png, image/jpeg"
                      fileList={(info?.container_info?.core_temperature1_pic || [])}
                      multiple
                      maxCount={1}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {((info?.container_info?.core_temperature1_pic || []).length) ? '' : <><Button icon={<UploadOutlined />}>上传图片</Button></>}
                      </div>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
              <Index list={info?.container_info?.core_temperature1_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'core_temperature1_pic', 'container_info')} />
              <Row>
                <Col span={8}>
                  <Form.Item size='small' colon={false} label="果心2" required>
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="core_temperature2" noStyle rules={[{ required: true, message: '请填写果心2温度!', },]}>
                        <InputNumber disabled={!canEdit} controls={false} precision={1} />
                      </Form.Item>
                      <span>℃</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item size='small' name="core_temperature2_pic" rules={[{ required: true, message: '请上传果心2照片!', }]}>
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      customRequest={(file) => pic_change(file, 'core_temperature2_pic', 'container_info')}
                      accept="image/png, image/jpeg"
                      fileList={(info?.container_info?.core_temperature2_pic || [])}
                      multiple
                      maxCount={1}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {((info?.container_info?.core_temperature2_pic || []).length) ? '' : <><Button icon={<UploadOutlined />}>上传图片</Button></>}
                      </div>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
              <Index list={info?.container_info?.core_temperature2_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'core_temperature2_pic', 'container_info')} />
              <Row>
                <Col span={8}>
                  <Form.Item size='small' colon={false} label="果心3" required>
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="core_temperature3" noStyle rules={[{ required: true, message: '请填写果心3温度!', },]}>
                        <InputNumber disabled={!canEdit} controls={false} precision={1} />
                      </Form.Item>
                      <span>℃</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item size='small' name="core_temperature3_pic" rules={[{ required: true, message: '请上传果心3照片!' }]}>
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      customRequest={(file) => pic_change(file, 'core_temperature3_pic', 'container_info')}
                      accept="image/png, image/jpeg"
                      fileList={(info?.container_info?.core_temperature3_pic || [])}
                      multiple
                      maxCount={1}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {((info?.container_info?.core_temperature3_pic || []).length) ? '' : <><Button icon={<UploadOutlined />}>上传图片</Button></>}
                      </div>
                    </Upload>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item size='small' colon={false} label="平均温度">
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="core_temperature_average" noStyle>
                        <InputNumber disabled controls={false} precision={1} />
                      </Form.Item>
                      <span>℃</span>
                    </div>
                  </Form.Item>
                </Col>
              </Row>
              <Index list={info?.container_info?.core_temperature3_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'core_temperature3_pic', 'container_info')} />
              <Row><Col span={24}><span>IOT编号及温度</span></Col></Row>
              <Row>
                <Col span={8}>
                  <Form.Item size='small' colon={false} label="IOT1编码" name="IOT1_no" rules={[{ required: true, message: '请填写IOT1编码!' }]}>
                    <Input disabled={!canEdit} />
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item size='small' colon={false} label="温度" required>
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="IOT1_no_temperature" noStyle rules={[{ required: true, message: '请填写温度!' }]} >
                        <InputNumber disabled={!canEdit} controls={false} precision={1} />
                      </Form.Item>
                      <span>℃</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item size='small' name="IOT1_no_temperature_pic" rules={[{ required: true, message: '请上传照片!', }]}>
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      customRequest={(file) => pic_change(file, 'IOT1_no_temperature_pic', 'container_info')}
                      accept="image/png, image/jpeg"
                      fileList={(info?.container_info?.IOT1_no_temperature_pic || [])}
                      multiple
                      maxCount={1}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {((info?.container_info?.IOT1_no_temperature_pic || []).length) ? '' : <><Button icon={<UploadOutlined />}>上传图片</Button></>}
                      </div>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
              <Index list={info?.container_info?.IOT1_no_temperature_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'IOT1_no_temperature_pic', 'container_info')} />
              <Row>
                <Col span={8}>
                  <Form.Item size='small' colon={false} label="IOT2编码" name="IOT2_no"  >
                    <Input disabled={!canEdit} />
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item size='small' colon={false} label="温度" >
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="IOT2_no_temperature" noStyle  >
                        <InputNumber disabled={!canEdit} controls={false} precision={1} />
                      </Form.Item>
                      <span>℃</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item size='small' name="IOT2_no_temperature_pic" >
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      customRequest={(file) => pic_change(file, 'IOT2_no_temperature_pic', 'container_info')}
                      accept="image/png, image/jpeg"
                      fileList={(info?.container_info?.IOT2_no_temperature_pic || [])}
                      multiple
                      maxCount={1}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {((info?.container_info?.IOT2_no_temperature_pic || []).length) ? '' : <><Button icon={<UploadOutlined />}>上传图片</Button></>}
                      </div>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
              <Index list={info?.container_info?.IOT2_no_temperature_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'IOT2_no_temperature_pic', 'container_info')} />
              <Row>
                <Col span={8}>
                  <Form.Item size='small' colon={false} label="IOT3编码" name="IOT3_no" >
                    <Input disabled={!canEdit} />
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item size='small' colon={false} label="温度" >
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="IOT3_no_temperature" noStyle >
                        <InputNumber disabled={!canEdit} controls={false} precision={1} />
                      </Form.Item>
                      <span>℃</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item size='small' name="IOT3_no_temperature_pic" >
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      customRequest={(file) => pic_change(file, 'IOT3_no_temperature_pic', 'container_info')}
                      accept="image/png, image/jpeg"
                      fileList={(info?.container_info?.IOT3_no_temperature_pic || [])}
                      multiple
                      maxCount={1}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {((info?.container_info?.IOT3_no_temperature_pic || []).length) ? '' : <><Button icon={<UploadOutlined />}>上传图片</Button></>}
                      </div>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
              <Index list={info?.container_info?.IOT3_no_temperature_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'IOT3_no_temperature_pic', 'container_info')} />
              {/* <Row>
                <Col span={8}>
                  <Form.Item size='small' colon={false} label="果心温度" required>
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="core_temperature" noStyle rules={[{ required: true, message: '请填写果心温度!', },]}>
                        <InputNumber disabled={!canEdit} controls={false} precision={1} />
                      </Form.Item>
                      <span>℃</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={10}>
                  <Form.Item size='small' name="core_temperature_pic" rules={[{ required: true, message: '请上传柜头、中、尾各传2张!', }, { validator }]}>
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      // customRequest={(file) => core_temperature_pic_change(file)}
                      accept="image/png, image/jpeg"
                      fileList={(info?.container_info?.core_temperature_pic || [])}
                      disabled={!canEdit}
                      maxCount={6}
                      multiple
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {((info?.container_info?.core_temperature_pic || []).length < 6) && <><Button icon={<UploadOutlined />}>上传图片</Button><span className='upload-span'>柜头、中、尾各传2张</span></>}
                      </div>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
              <Index list={info?.container_info?.core_temperature_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={core_temperature_pic_remove} /> */}
              {/* <Row>
                <Col span={8}>
                  <Form.Item size='small' colon={false} label="开柜味道" name="container_taste" rules={[{ required: true, message: '请选择开柜味道!', },]} >
                    <Select disabled={!canEdit}>{(containerTasteList || []).map(item => <Option key={item.name} value={item.name}>{item.name}</Option>)}</Select>
                  </Form.Item>
                </Col>
                <Col span={8}></Col>
                <Col span={8}></Col>
              </Row> */}
              {/* <Row>
                <Col span={6}>
                  <Form.Item size='small' colon={false} label="湿箱数量" required>
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="container_wet_number" noStyle rules={[{ required: true, message: '请填写温度!', },]} wrapperCol={{ span: 4 }}>
                        <InputNumber disabled={!canEdit} controls={false} precision={1} />
                      </Form.Item>
                      <span>箱</span>
                    </div>
                  </Form.Item>
                </Col>
              </Row> */}
              <Row>
                <Col span={6}>
                  <Form.Item size='small' colon={false} label="香气" name="container_taste" rules={[{ required: true, message: '请选择香气!', },]} >
                    <Select disabled={!canEdit}>{(containerTasteList || []).map(item => <Option key={item.name} value={item.name}>{item.name}</Option>)}</Select>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item size='small' colon={false} label="具体说明" wrapperCol={{ span: 16 }} required={container_taste_required} rules={[{ required: container_taste_required, message: '请输入香气说明' }]}>
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="container_taste_desc" noStyle rules={[{ required: container_taste_required, message: '请输入香气说明' }]} >
                        <Input disabled={!canEdit} controls={false} />
                      </Form.Item>
                      <span style={{ width: 150 }}>例如：酒精味</span>
                    </div>
                  </Form.Item>
                </Col>
              </Row>
              <div className='quality-report-title'>抽样质检</div>
              <Row>
                <Col span={8}>
                  <Form.Item size='small' colon={false} label="抽样" required>
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="sample_number" noStyle rules={[{ required: true, message: '请填写抽样!', },]}>
                        <InputNumber disabled={!canEdit} controls={false} min={1} precision={0} />
                      </Form.Item>
                      <span>箱</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item size='small' colon={false} label="共计" required>
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="total_number" noStyle rules={[{ required: true, message: '请填写共计!', },]}>
                        <InputNumber disabled={!canEdit} controls={false} min={1} precision={0} />
                      </Form.Item>
                      <span>个</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item size='small' colon={false} label="占比" >
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="sample_number_percent" defaultValue={computed_sample_number_percent()} noStyle >
                        <Input disabled />
                      </Form.Item>
                      <span>%</span>
                    </div>
                  </Form.Item>
                </Col>
              </Row>
              <Table
                className='quality-table'
                bordered
                dataSource={dataSource}
                columns={columns2}
                pagination={false}
                rowKey='sale_id'
              />
              <div className='quality-report-title'>单件称重</div>
              {(weight_data || []).map((item, idx) => (
                <div key={idx} style={{ marginBottom: 20 }}>
                  <Row style={{ marginBottom: 8 }}>
                    <Col span={6}>
                      <span style={{ marginLeft: 8 }}>单位重量 {item?.base_factor}kg</span>
                    </Col>
                    <Col span={6}>
                      称重箱数 <span style={{ marginLeft: 8 }}>{item?.weight_number}箱</span>
                    </Col>
                  </Row>
                  <Table
                    className='quality-table'
                    bordered
                    dataSource={item?.weight_source || []}
                    columns={columns3.map(col => {
                      if (col.key === 'weight_info') {
                        return {
                          ...col,
                          render: (text, record, posIdx) => {
                            const weightIdx = weight_data.findIndex(weightItem =>
                              weightItem.base_factor === item.base_factor
                            );
                            return (
                              <div>
                                {record.single_data.map((data, dataIdx) => (
                                  <div key={dataIdx} style={{ marginBottom: 8, display: 'flex', alignItems: 'center', gap: 8 }}>
                                    <span>{dataIdx + 1}</span>
                                    <Form.Item size='small' colon={false} name={`single_weight_number_${weightIdx}_${posIdx}_${dataIdx}`} rules={[{ required: true, message: '请输入称重!' }]}>
                                      <InputNumber
                                        placeholder='请输入称重'
                                        precision={2}
                                        onChange={(value) => handleSingleWeightChange(value, weightIdx, posIdx, dataIdx)}
                                        style={{ width: 120 }}
                                        disabled={!canEdit}
                                        defaultValue={data.single_weight_number}
                                      />
                                    </Form.Item>
                                    <Form.Item size='small' colon={false} name={`single_weight_pic_${weightIdx}_${posIdx}_${dataIdx}`} rules={[{ required: true, message: '请上传!', },]}>
                                      <Upload
                                        name="file"
                                        headers={{ token: localStorage.getItem('token') }}
                                        showUploadList={false}
                                        fileList={(data?.single_weight_pic || [])}
                                        customRequest={(file) => weight_change(file, weightIdx, posIdx, dataIdx)}
                                        accept="image/png, image/jpeg"
                                        maxCount={1}
                                        disabled={!canEdit}
                                      >
                                        <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                                          {(data?.single_weight_pic || []).length ? '' : <Button icon={<UploadOutlined />}>上传图片</Button>}
                                        </div>
                                      </Upload>
                                      {(data?.single_weight_pic || []).length ? <div style={{ width: 50, height: 50 }}><Index list={data?.single_weight_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => { weight_remove(e, weightIdx, posIdx, dataIdx); }} /></div> : ''}
                                    </Form.Item>
                                  </div>
                                ))}
                              </div>
                            );
                          }
                        };
                      } else if (col.key === 'package_weight') {
                        return {
                          ...col,
                          render: (text, record, posIdx) => {
                            const weightIdx = weight_data.findIndex(weightItem =>
                              weightItem.base_factor === item.base_factor
                            );
                            return (
                              <InputNumber
                                placeholder='请输入包装重量'
                                precision={2}
                                value={text}
                                onChange={(value) => handlePackageWeightChange(value, weightIdx, posIdx)}
                                style={{ width: 100 }}
                                disabled={!canEdit}
                              />
                            );
                          }
                        };
                      }
                      return col;
                    })}
                    pagination={false}
                    rowKey={(record) => record.position}
                  />
                </div>
              ))}
              {/* <Row>
                <Col span={19}>
                  <Form.Item size='small' colon={false} labelCol={{ span: 3 }} label="称重图片" name="weight_pic" rules={[{ required: true, message: '请上传称重图片!', }, { validator }]}>
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      customRequest={(file) => weight_pic_change(file)}
                      accept="image/png, image/jpeg"
                      fileList={(info?.weight_info?.weight_pic || [])}
                      multiple
                      maxCount={6}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {((info?.weight_info?.weight_pic || []).length < 6) && <><Button icon={<UploadOutlined />}>上传图片</Button><span className='upload-span'>请上传6张称重图片</span></>}
                      </div>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
              <Index list={info?.weight_info?.weight_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={weight_pic_remove} />
              <Row>
                <Col span={8}>
                  <Form.Item size='small' colon={false} label="平均毛重" required wrapperCol={{ span: 12 }}>
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="average_weight" noStyle rules={[{ required: true, message: '请填写平均毛重!', },]}>
                        <InputNumber disabled={!canEdit} controls={false} precision={2} min={0.01} />
                      </Form.Item>
                      <span>kg</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item size='small' colon={false} label="包装重" required wrapperCol={{ span: 12 }} >
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="package_weight" noStyle rules={[{ required: true, message: '请填包装重!', },]}>
                        <InputNumber disabled={!canEdit} controls={false} precision={2} min={0.01} />
                      </Form.Item>
                      <span>kg</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item size='small' colon={false} label="平均净重" required wrapperCol={{ span: 12 }}>
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="average_net_weight" noStyle defaultValue={computed_average_net_weight()} rules={[{ required: true, message: '请填写平均净重!', },]}>
                        <Input disabled />
                      </Form.Item>
                      <span>kg</span>
                    </div>
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={8}>
                  <Form.Item size='small' colon={false} label="标准净重" required wrapperCol={{ span: 12 }}>
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="standard_weight" noStyle rules={[{ required: true, message: '请填写标准净重!', },]}>
                        <InputNumber precision={2} min={0.01} disabled={!canEdit} />
                      </Form.Item>
                      <span>kg</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item size='small' colon={false} label="偏差" required wrapperCol={{ span: 12 }}>
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="weight_deviation" noStyle rules={[{ required: true, message: '请填写偏差!', },]}>
                        <Input disabled />
                      </Form.Item>
                      <span>kg</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item size='small' colon={false} label="偏差占比" required wrapperCol={{ span: 12 }}>
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="weight_deviation_percent" noStyle rules={[{ required: true, message: '请填写偏差占比!', },]}>
                        <Input disabled />
                      </Form.Item>
                      <span>%</span>
                    </div>
                  </Form.Item>
                </Col>
              </Row> */}
              {/* <Row>
                <Col span={8}>
                  <Form.Item size='small' colon={false} label="是否达标" name="is_standard" rules={[{ required: true, message: '请选择是否达标!', },]} >
                    <Select disabled={!canEdit}>{['达标', '不达标'].map(item => <Option key={item} value={item}>{item}</Option>)}</Select>
                  </Form.Item>
                </Col>
                <Col span={8}></Col>
                <Col span={8}></Col>
              </Row> */}
              <div className='quality-report-title'>果形</div>
              <Row gutter={4}>
                <Col span={8}>
                  <Form.Item size='small' colon={false} name="poor_fruit_shape" wrapperCol={{ span: 24 }}>
                    <Radio.Group vertical size="small" >
                      <Radio value='正常'>正常</Radio>
                      <Radio value='果形欠佳(不端正、欠规则、欠饱满)'>果形欠佳(不端正、欠规则、欠饱满)</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                <Col span={3}>
                  <Form.Item size='small' colon={false} label=" " required={poor_fruit_shape_required} rules={[{ required: poor_fruit_shape_required, message: '请填写数量!' }]}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <Form.Item size='small' name="poor_fruit_shape_number" noStyle rules={[{ required: poor_fruit_shape_required, message: '请填写数量!', },]}>
                        <InputNumber disabled={!canEdit} controls={false} min={0} precision={0} style={{ width: 100 }} />
                      </Form.Item>
                      <span>个</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={3}>
                  <Form.Item size='small' colon={false} label="占比" >
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="poor_fruit_shape_number_percent" noStyle defaultValue={computed_poor_fruit_shape_number_percent()}>
                        <Input disabled style={{ width: 60 }} />
                      </Form.Item>
                      <span>%</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    size='small'
                    colon={false}
                    name="poor_fruit_shape_number_pic"
                    required={poor_fruit_shape_required}
                    rules={[{ required: poor_fruit_shape_required, message: '请上传问题果图片!' }]}
                    label=' '
                  >
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      customRequest={(file) => poor_fruit_shape_number_pic_change(file)}
                      accept="image/png, image/jpeg"
                      fileList={(info?.fruit_shape?.poor_fruit_shape_number_pic || [])}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {(info?.fruit_shape?.poor_fruit_shape_number_pic || []).length ? '' : <><Button icon={<UploadOutlined />}>上传图片</Button></>}
                      </div>
                      <span className='upload-span'>请将问题果放在一起拍照</span>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
              <Index list={info?.fruit_shape?.poor_fruit_shape_number_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={poor_fruit_shape_number_pic_remove} />
              <Row>
                <Col span={24}>
                  <Form.Item size='small' name="poor_fruit_shape_describe" colon={false} rules={[{ required: poor_fruit_shape_required, message: '请填写描述!' }]} label='描述' labelCol={6}><Input disabled={!canEdit} placeholder={canEdit ? '请说明该问题果来自柜中/柜头/柜尾' : ''} /></Form.Item>
                </Col>
              </Row>
              <div className='quality-report-title'>房数</div>
              <Row gutter={4}>
                <Col span={6}>
                  <Form.Item size='small' colon={false} name="fruit_house" wrapperCol={{ span: 24 }} >
                    <Radio.Group vertical size='small' >
                      <Radio value='正常'>正常</Radio>
                      <Radio value='房数不达标'>房数不达标</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                <Col span={3}>
                  <Form.Item size='small' colon={false} label=" " required={fruit_house_required} rules={[{ required: fruit_house_required, message: '请填写数量!' }]}>
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="fruit_house_number" noStyle rules={[{ required: fruit_house_required, message: '请填写数量!', },]}>
                        <InputNumber disabled={!canEdit} controls={false} min={0} precision={0} />
                      </Form.Item>
                      <span>个</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item size='small' colon={false} label="占比" >
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="fruit_house_number_percent" noStyle >
                        <Input disabled value={computed_fruit_house_number_percent()} />
                      </Form.Item>
                      <span>%</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item size='small' name="fruit_house_shape_number_pic" wrapperCol={{ span: 24 }} label=' ' colon={false} rules={[{ required: fruit_house_required, message: '请上传房数照片!' }]} >
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      customRequest={(file) => pic_change(file, 'fruit_house_shape_number_pic', 'fruit_shape')}
                      accept="image/png, image/jpeg"
                      fileList={(info?.fruit_shape?.fruit_house_shape_number_pic || [])}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {(info?.fruit_shape?.fruit_house_shape_number_pic || []).length ? '' : <><Button icon={<UploadOutlined />}>上传图片</Button></>}
                      </div>
                      <span className='upload-span'>照片必须展示带子、品牌和等级</span>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
              <Index list={info?.fruit_shape?.fruit_house_shape_number_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'fruit_house_shape_number_pic', 'fruit_shape')} />
              <Row>
                <Col span={4}>
                  <Form.Item size='small' colon={false} label="3房" >
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="fruit_house_number_3" noStyle >
                        <Input disabled={!canEdit} />
                      </Form.Item>
                      <span>个</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item size='small' colon={false} label="占比" >
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="fruit_house_number_3_percent" noStyle >
                        <Input disabled defaultValue={computed_fruit_house_number_3_percent()} />
                      </Form.Item>
                      <span>%</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item size='small' name="fruit_house_number_3_pic"  >
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      customRequest={(file) => pic_change(file, 'fruit_house_number_3_pic', 'fruit_shape')}
                      accept="image/png, image/jpeg"
                      fileList={(info?.fruit_shape?.fruit_house_number_3_pic || [])}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {(info?.fruit_shape?.fruit_house_number_3_pic || []).length ? '' : <><Button icon={<UploadOutlined />}>上传图片</Button></>}
                      </div>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
              <Index list={info?.fruit_shape?.fruit_house_number_3_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'fruit_house_number_3_pic', 'fruit_shape')} />
              <Row>
                <Col span={4}>
                  <Form.Item size='small' colon={false} label="3.5房" >
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="fruit_house_number_35" noStyle >
                        <Input disabled={!canEdit} />
                      </Form.Item>
                      <span>个</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item size='small' colon={false} label="占比" >
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="fruit_house_number_35_percent" noStyle >
                        <Input disabled value={computed_fruit_house_number_35_percent()} />
                      </Form.Item>
                      <span>%</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item size='small' name="fruit_house_number_35_pic"  >
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      customRequest={(file) => pic_change(file, 'fruit_house_number_35_pic', 'fruit_shape')}
                      accept="image/png, image/jpeg"
                      fileList={(info?.fruit_shape?.fruit_house_number_35_pic || [])}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {(info?.fruit_shape?.fruit_house_number_35_pic || []).length ? '' : <><Button icon={<UploadOutlined />}>上传图片</Button></>}
                      </div>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
              <Index list={info?.fruit_shape?.fruit_house_number_35_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'fruit_house_number_35_pic', 'fruit_shape')} />
              <Row>
                <Col span={5}>
                  <Form.Item size='small' colon={false} label="4房及以上" >
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="fruit_house_number_4" noStyle >
                        <Input disabled={!canEdit} />
                      </Form.Item>
                      <span>个</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item size='small' colon={false} label="占比" >
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="fruit_house_number_4_percent" noStyle >
                        <Input disabled value={computed_fruit_house_number_4_percent()} />
                      </Form.Item>
                      <span>%</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item size='small' name="fruit_house_number_4_pic"  >
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      customRequest={(file) => pic_change(file, 'fruit_house_number_4_pic', 'fruit_shape')}
                      accept="image/png, image/jpeg"
                      fileList={(info?.fruit_shape?.fruit_house_number_4_pic || [])}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {(info?.fruit_shape?.fruit_house_number_4_pic || []).length ? '' : <><Button icon={<UploadOutlined />}>上传图片</Button></>}
                      </div>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
              <Index list={info?.fruit_shape?.fruit_house_number_4_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'fruit_house_number_4_pic', 'fruit_shape')} />
              <div className='quality-report-title'>果柄</div>
              <Row gutter={8}>
                <Col span={10}>
                  <Form.Item size='small' colon={false} name="fruit_stalk_type" wrapperCol={{ span: 24 }}>
                    <Radio.Group vertical size='small'>
                      <Radio value='正常'>正常</Radio>
                      <Radio value='果柄有缺陷'>果柄有缺陷（果柄出现霉斑的问题已被归类为外部缺陷）</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={4}>
                  <Form.Item size='small' colon={false} label="断柄" >
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="fruit_stalk_broken" noStyle >
                        <InputNumber disabled={!canEdit} />
                      </Form.Item>
                      <span>个</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item size='small' colon={false} label="占比" >
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="fruit_stalk_broken_percent" noStyle >
                        <Input disabled value={computed_fruit_stalk_broken_percent()} />
                      </Form.Item>
                      <span>%</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item size='small' name="fruit_stalk_broken_pic"  >
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      customRequest={(file) => pic_change(file, 'fruit_stalk_broken_pic', 'fruit_stalk')}
                      accept="image/png, image/jpeg"
                      fileList={(info?.fruit_stalk?.fruit_stalk_broken_pic || [])}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {(info?.fruit_stalk?.fruit_stalk_broken_pic || []).length ? '' : <><Button icon={<UploadOutlined />}>上传图片</Button></>}
                      </div>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
              <Index list={info?.fruit_stalk?.fruit_stalk_broken_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'fruit_stalk_broken_pic', 'fruit_stalk')} />
              <Row>
                <Col span={4}>
                  <Form.Item size='small' colon={false} label="少柄" >
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="fruit_stalk_lacking" noStyle >
                        <Input disabled={!canEdit} />
                      </Form.Item>
                      <span>个</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item size='small' colon={false} label="占比" >
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="fruit_stalk_lacking_percent" noStyle >
                        <Input disabled defaultValue={computed_fruit_stalk_lacking_percent()} />
                      </Form.Item>
                      <span>%</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item size='small' name="fruit_stalk_lacking_pic"  >
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      customRequest={(file) => pic_change(file, 'fruit_stalk_lacking_pic', 'fruit_stalk')}
                      accept="image/png, image/jpeg"
                      fileList={(info?.fruit_stalk?.fruit_stalk_lacking_pic || [])}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {(info?.fruit_stalk?.fruit_stalk_lacking_pic || []).length ? '' : <><Button icon={<UploadOutlined />}>上传图片</Button></>}
                      </div>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
              <Index list={info?.fruit_stalk?.fruit_stalk_lacking_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'fruit_stalk_lacking_pic', 'fruit_stalk')} />
              <Row>
                <Col span={4}>
                  <Form.Item size='small' colon={false} label="烂柄" >
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="fruit_stalk_rotten" noStyle >
                        <Input disabled={!canEdit} />
                      </Form.Item>
                      <span>个</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item size='small' colon={false} label="占比" >
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="fruit_stalk_rotten_percent" noStyle >
                        <Input disabled defaultValue={computed_fruit_stalk_rotten_percent()} />
                      </Form.Item>
                      <span>%</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item size='small' name="fruit_stalk_rotten_pic"  >
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      customRequest={(file) => pic_change(file, 'fruit_stalk_rotten_pic', 'fruit_stalk')}
                      accept="image/png, image/jpeg"
                      fileList={(info?.fruit_stalk?.fruit_stalk_rotten_pic || [])}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {(info?.fruit_stalk?.fruit_stalk_rotten_pic || []).length ? '' : <><Button icon={<UploadOutlined />}>上传图片</Button></>}
                      </div>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
              <Index list={info?.fruit_stalk?.fruit_stalk_rotten_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'fruit_stalk_rotten_pic', 'fruit_stalk')} />
              <Row>
                <Col span={4}>
                  <Form.Item size='small' colon={false} label="总计" >
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="fruit_stalk_number" noStyle >
                        <InputNumber disabled={!canEdit} controls={false} precision={0} min={0} defaultValue={computed_fruit_stalk_number()} />
                      </Form.Item>
                      <span>个</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item size='small' colon={false} label="占比" >
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="fruit_stalk_number_percent" noStyle >
                        <Input disabled defaultValue={computed_fruit_stalk_number_percent()} />
                      </Form.Item>
                      <span>%</span>
                    </div>
                  </Form.Item>
                </Col>
              </Row>
              <div className='quality-report-title'>颜色</div>
              <Row>
                <Col span={5}>
                  <Form.Item size='small' colon={false} label="1号色" >
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="fruit_color_1" noStyle >
                        <Input disabled={!canEdit} />
                      </Form.Item>
                      <span>个</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item size='small' colon={false} label="占比" >
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="fruit_color_1_percent" noStyle >
                        <Input disabled defaultValue={computed_fruit_color_1_percent()} />
                      </Form.Item>
                      <span>%</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item size='small' name="fruit_color_1_pic"  >
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      customRequest={(file) => pic_change(file, 'fruit_color_1_pic', 'colour_info')}
                      accept="image/png, image/jpeg"
                      fileList={(info?.colour_info?.fruit_color_1_pic || [])}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {(info?.colour_info?.fruit_color_1_pic || []).length ? '' : <><Button icon={<UploadOutlined />}>上传图片</Button></>}
                      </div>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
              <Index list={info?.colour_info?.fruit_color_1_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'fruit_color_1_pic', 'colour_info')} />
              <Row>
                <Col span={5}>
                  <Form.Item size='small' colon={false} label="2号色" >
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="fruit_color_2" noStyle >
                        <Input disabled={!canEdit} />
                      </Form.Item>
                      <span>个</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item size='small' colon={false} label="占比" >
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="fruit_color_2_percent" noStyle >
                        <Input disabled defaultValue={computed_fruit_color_2_percent()} />
                      </Form.Item>
                      <span>%</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item size='small' name="fruit_color_2_pic"  >
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      customRequest={(file) => pic_change(file, 'fruit_color_2_pic', 'colour_info')}
                      accept="image/png, image/jpeg"
                      fileList={(info?.colour_info?.fruit_color_2_pic || [])}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {(info?.colour_info?.fruit_color_2_pic || []).length ? '' : <><Button icon={<UploadOutlined />}>上传图片</Button></>}
                      </div>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
              <Index list={info?.colour_info?.fruit_color_2_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'fruit_color_2_pic', 'colour_info')} />
              <Row>
                <Col span={5}>
                  <Form.Item size='small' colon={false} label="3号色" >
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="fruit_color_3" noStyle >
                        <Input disabled={!canEdit} />
                      </Form.Item>
                      <span>个</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item size='small' colon={false} label="占比" >
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="fruit_color_3_percent" noStyle >
                        <Input disabled defaultValue={computed_fruit_color_3_percent()} />
                      </Form.Item>
                      <span>%</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item size='small' name="fruit_color_3_pic"  >
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      customRequest={(file) => pic_change(file, 'fruit_color_3_pic', 'colour_info')}
                      accept="image/png, image/jpeg"
                      fileList={(info?.colour_info?.fruit_color_3_pic || [])}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {(info?.colour_info?.fruit_color_3_pic || []).length ? '' : <><Button icon={<UploadOutlined />}>上传图片</Button></>}
                      </div>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
              <Index list={info?.colour_info?.fruit_color_3_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'fruit_color_3_pic', 'fruit_color')} />
              <Row>
                <Col span={5}>
                  <Form.Item size='small' colon={false} label="4号色" >
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="fruit_color_4" noStyle >
                        <Input disabled={!canEdit} />
                      </Form.Item>
                      <span>个</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item size='small' colon={false} label="占比" >
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="fruit_color_4_percent" noStyle >
                        <Input disabled defaultValue={computed_fruit_color_4_percent()} />
                      </Form.Item>
                      <span>%</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item size='small' name="fruit_color_4_pic"  >
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      customRequest={(file) => pic_change(file, 'fruit_color_4_pic', 'colour_info')}
                      accept="image/png, image/jpeg"
                      fileList={(info?.colour_info?.fruit_color_4_pic || [])}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {(info?.colour_info?.fruit_color_4_pic || []).length ? '' : <><Button icon={<UploadOutlined />}>上传图片</Button></>}
                      </div>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
              <Index list={info?.colour_info?.fruit_color_4_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'fruit_color_4_pic', 'colour_info')} />
              {/* <Row>
                <Col span={24}>
                  <Form.Item size='small' name="fruit_color" colon={false} label="整体果色" labelCol={6} wrapperCol={18} rules={[{ required: true, message: '请选择整体果色!', },]}>
                    <Checkbox.Group disabled={!canEdit}>
                      {(fruitColorList || []).map(item => <Checkbox key={item.name} value={item.name} style={{ lineHeight: '32px', }}>{item.name}</Checkbox>)}
                    </Checkbox.Group>
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <Form.Item size='small' name="colour_info_describe" colon={false} label='描述' labelCol={6} ><Input disabled={!canEdit} /></Form.Item>
                </Col>
              </Row> */}
              <div className='quality-report-title'>果皮缺陷</div>
              <Row gutter={4}>
                <Col span={8}>
                  <Form.Item size='small' colon={false} name="fruit_peel_type" wrapperCol={{ span: 24 }}>
                    <Radio.Group vertical size='small'>
                      <Radio value='正常'>正常</Radio>
                      <Radio value='果皮有缺陷'>果皮有缺陷</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={12}>
                  <Row>
                    <Col span={12}>
                      <Form.Item size='small' colon={false} label="红刺果" required={fruit_peel_type_required} rules={[{ required: fruit_peel_type_required, message: '请输入红刺果数量!' }]}>
                        <div style={{ display: 'flex', 'alignItems': 'center' }}>
                          <Form.Item size='small' name="red_thorn_fruit" noStyle >
                            <InputNumber disabled={!canEdit} controls={false} min={0} precision={0} />
                          </Form.Item>
                          <span>个</span>
                        </div>
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item size='small' colon={false} label="占比" labelCol={{ span: 12 }}>
                        <div style={{ display: 'flex', 'alignItems': 'center' }}>
                          <Form.Item size='small' name="red_thorn_fruit_percent" defaultValue={computed_red_thorn_fruit_percent()} noStyle>
                            <Input disabled />
                          </Form.Item>
                          <span>%</span>
                        </div>
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
                <Col span={12}>
                  <Row>
                    <Col span={12}>
                      <Form.Item size='small' colon={false} label="褐色果" required={fruit_peel_type_required} rules={[{ required: fruit_peel_type_required, message: '请输入褐色果数量!' }]}>
                        <div style={{ display: 'flex', 'alignItems': 'center' }}>
                          <Form.Item size='small' name="brown_fruit" noStyle>
                            <InputNumber disabled={!canEdit} controls={false} min={0} precision={0} />
                          </Form.Item>
                          <span>个</span>
                        </div>
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item size='small' colon={false} label="占比" labelCol={{ span: 12 }} >
                        <div style={{ display: 'flex', 'alignItems': 'center' }}>
                          <Form.Item size='small' name="brown_fruit_percent" defaultValue={computed_brown_fruit_percent()} noStyle>
                            <Input disabled />
                          </Form.Item>
                          <span>%</span>
                        </div>
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col span={12}>
                  <Row>
                    <Col span={12}>
                      <Form.Item size='small' colon={false} label="全清果" required={fruit_peel_type_required} rules={[{ required: fruit_peel_type_required, message: '请输入全清果数量!' }]}>
                        <div style={{ display: 'flex', 'alignItems': 'center' }}>
                          <Form.Item size='small' name="whole_green_fruit" noStyle >
                            <InputNumber disabled={!canEdit} controls={false} min={0} precision={0} />
                          </Form.Item>
                          <span>个</span>
                        </div>
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item size='small' colon={false} label="占比" labelCol={{ span: 12 }} >
                        <div style={{ display: 'flex', 'alignItems': 'center' }}>
                          <Form.Item size='small' name="whole_green_fruit_percent" defaultValue={computed_whole_green_fruit_percent()} noStyle >
                            <Input disabled />
                          </Form.Item>
                          <span>%</span>
                        </div>
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
                <Col span={12}>
                  <Row>
                    <Col span={12}>
                      <Form.Item size='small' colon={false} label="其他果" required={fruit_peel_type_required} rules={[{ required: fruit_peel_type_required, message: '请输入其他果数量!' }]}>
                        <div style={{ display: 'flex', 'alignItems': 'center' }}>
                          <Form.Item size='small' name="other_fruit" noStyle >
                            <InputNumber disabled={!canEdit} controls={false} min={0} precision={0} />
                          </Form.Item>
                          <span>个</span>
                        </div>
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item size='small' colon={false} label="占比" labelCol={{ span: 12 }}>
                        <div style={{ display: 'flex', 'alignItems': 'center' }}>
                          <Form.Item size='small' name="other_fruit_percent" defaultValue={computed_other_fruit_percent()} noStyle >
                            <Input disabled />
                          </Form.Item>
                          <span>%</span>
                        </div>
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col span={6}>
                  <Form.Item size='small' colon={false} label="总计">
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="fruit_peel_number" noStyle>
                        <InputNumber disabled={!canEdit} controls={false} min={0} precision={0} value={computed_fruit_peel_number()} />
                      </Form.Item>
                      <span>个</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item size='small' colon={false} label="占比" labelCol={{ span: 12 }} >
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="brown_fruit_total_percent" noStyle>
                        <Input disabled defaultValue={computed_fruit_peel_number_percent()} />
                      </Form.Item>
                      <span>%</span>
                    </div>
                  </Form.Item>
                </Col>
              </Row>
              <div className='quality-report-title'>果壳 外部问题</div>
              <Row gutter={4}>
                <Col span={8}>
                  <Form.Item size='small' colon={false} name="fruit_shell_type" wrapperCol={{ span: 24 }}>
                    <Radio.Group vertical size='small'>
                      <Radio value='正常'>正常</Radio>
                      <Radio value='有异常'>有异常</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </Row>
              <div>果壳表面损坏</div>
              <div style={{ border: '1px solid #efefef', padding: '10px', margin: '10px 10px 30px' }}>
                <div>其中：</div>
                <Row>
                  <Col span={9}>
                    <Form.Item size='small' colon={false} label="虫眼" wrapperCol={{ span: 12 }}>
                      <div style={{ display: 'flex', 'alignItems': 'center' }}>
                        <Form.Item size='small' name="wormhole_fruit" noStyle>
                          <InputNumber disabled={!canEdit} controls={false} min={0} precision={0} />
                        </Form.Item>
                        <span>个</span>
                      </div>
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item size='small' colon={false} label="占比" >
                      <div style={{ display: 'flex', 'alignItems': 'center' }}>
                        <Form.Item size='small' name="wormhole_fruit_percent" defaultValue={computed_wormhole_fruit_percent()} noStyle >
                          <Input disabled />
                        </Form.Item>
                        <span>%</span>
                      </div>
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item size='small' name="wormhole_fruit_pic" rules={[{ required: wormhole_fruit_required, message: '请上传问题果图片!', },]}>
                      <Upload
                        name="file"
                        headers={{ token: localStorage.getItem('token') }}
                        showUploadList={false}
                        customRequest={(file) => pic_change(file, 'wormhole_fruit_pic', 'shuck_info')}
                        accept="image/png, image/jpeg"
                        fileList={(info?.shuck_info?.wormhole_fruit_pic || [])}
                        disabled={!canEdit}
                      >
                        <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                          {(info?.shuck_info?.wormhole_fruit_pic || []).length ? '' : <><Button icon={<UploadOutlined />}>上传图片</Button></>}
                        </div>
                      </Upload>
                    </Form.Item>
                  </Col>
                </Row>
                <Index list={info?.shuck_info?.wormhole_fruit_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'wormhole_fruit_pic', 'shuck_info')} />
                <Row>
                  <Col span={9}>
                    <Form.Item size='small' colon={false} label="烂丁/烂刺/烂疤" wrapperCol={{ span: 12 }}>
                      <div style={{ display: 'flex', 'alignItems': 'center' }}>
                        <Form.Item size='small' name="rotten_fruit" noStyle>
                          <InputNumber disabled={!canEdit} controls={false} min={0} precision={0} />
                        </Form.Item>
                        <span>个</span>
                      </div>
                      <span className='upload-span'>烂刺/烂丁面积超4cm²</span>
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item size='small' colon={false} label="占比">
                      <div style={{ display: 'flex', 'alignItems': 'center' }}>
                        <Form.Item size='small' name="rotten_fruit_percent" defaultValue={computed_rotten_fruit_percent()} noStyle >
                          <Input disabled />
                        </Form.Item>
                        <span>%</span>
                      </div>
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item size='small' name="rotten_fruit_pic" rules={[{ required: rotten_fruit_required, message: '请上传问题果图片!', },]}>
                      <Upload
                        name="file"
                        headers={{ token: localStorage.getItem('token') }}
                        showUploadList={false}
                        customRequest={(file) => pic_change(file, 'rotten_fruit_pic', 'shuck_info')}
                        accept="image/png, image/jpeg"
                        fileList={(info?.shuck_info?.rotten_fruit_pic || [])}
                        disabled={!canEdit}
                      >
                        <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                          {(info?.shuck_info?.rotten_fruit_pic || []).length ? '' : <><Button icon={<UploadOutlined />}>上传图片</Button></>}
                        </div>
                      </Upload>
                    </Form.Item>
                  </Col>
                </Row>
                <Index list={info?.shuck_info?.rotten_fruit_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'rotten_fruit_pic', 'shuck_info')} />
                <Row>
                  <Col span={9}>
                    <Form.Item size='small' colon={false} label="发霉" wrapperCol={{ span: 12 }}>
                      <div style={{ display: 'flex', 'alignItems': 'center' }}>
                        <Form.Item size='small' name="shuck_other_fruit" noStyle >
                          <InputNumber disabled={!canEdit} controls={false} min={0} precision={0} />
                        </Form.Item>
                        <span>个</span>
                      </div>
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item size='small' colon={false} label="占比" >
                      <div style={{ display: 'flex', 'alignItems': 'center' }}>
                        <Form.Item size='small' name="shuck_other_fruit_percent" defaultValue={computed_shuck_other_fruit_percent()} noStyle >
                          <Input disabled />
                        </Form.Item>
                        <span>%</span>
                      </div>
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item size='small' name="shuck_other_fruit_pic" rules={[{ required: shuck_other_fruit_required, message: '请上传问题果图片!', },]}>
                      <Upload
                        name="file"
                        headers={{ token: localStorage.getItem('token') }}
                        showUploadList={false}
                        customRequest={(file) => pic_change(file, 'shuck_other_fruit_pic', 'shuck_info')}
                        accept="image/png, image/jpeg"
                        fileList={(info?.shuck_info?.shuck_other_fruit_pic || [])}
                        disabled={!canEdit}
                      >
                        <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                          {(info?.shuck_info?.shuck_other_fruit_pic || []).length ? '' : <><Button icon={<UploadOutlined />}>上传图片</Button></>}
                        </div>
                      </Upload>
                    </Form.Item>
                  </Col>
                </Row>
                <Index list={info?.shuck_info?.shuck_other_fruit_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'shuck_other_fruit_pic', 'shuck_info')} />
                <Row>
                  <Col span={9}>
                    <Form.Item ize='small' colon={false} label="总计" wrapperCol={{ span: 12 }}>
                      <div style={{ display: 'flex', 'alignItems': 'center' }}>
                        <Form.Item size='small' name="shuck_other_fruit_number" noStyle>
                          <InputNumber disabled={!canEdit} controls={false} precision={0} min={0} defaultValue={computed_shuck_other_fruit_number()} />
                        </Form.Item>
                        <span>个</span>
                      </div>
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item size='small' colon={false} label="占比" >
                      <div style={{ display: 'flex', 'alignItems': 'center' }}>
                        <Form.Item size='small' name="shuck_other_fruit_number_percent" noStyle >
                          <Input disabled defaultValue={computed_shuck_other_fruit_number_percent()} />
                        </Form.Item>
                        <span>%</span>
                      </div>
                    </Form.Item>
                  </Col>
                </Row>
              </div>
              <div>裂口</div>
              <div style={{ border: '1px solid #efefef', padding: '10px', margin: '10px 10px 30px' }}>
                <div>单果开裂程度超过轴线高度的30%且能看到果肉</div>
                <Row>
                  <Col span={10}>
                    <Form.Item size='small' colon={false} label="开裂长度小于30%" wrapperCol={{ span: 12 }}>
                      <div style={{ display: 'flex', 'alignItems': 'center' }}>
                        <Form.Item size='small' name="cleft_fruit_low" noStyle >
                          <InputNumber disabled={!canEdit} controls={false} min={0} precision={0} />
                        </Form.Item>
                        <span>个</span>
                      </div>
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item size='small' colon={false} label="占比" >
                      <div style={{ display: 'flex', 'alignItems': 'center' }}>
                        <Form.Item size='small' name="cleft_fruit_low_percent" noStyle >
                          <Input disabled defaultValue={computed_cleft_fruit_low_percent()} />
                        </Form.Item>
                        <span>%</span>
                      </div>
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item size='small' name="cleft_fruit_low_pic" rules={[{ required: cleft_fruit_low_required, message: '请上传问题果图片!', },]}>
                      <Upload
                        name="file"
                        headers={{ token: localStorage.getItem('token') }}
                        showUploadList={false}
                        customRequest={(file) => pic_change(file, 'cleft_fruit_low_pic', 'shuck_info')}
                        accept="image/png, image/jpeg"
                        fileList={(info?.shuck_info?.cleft_fruit_low_pic || [])}
                        disabled={!canEdit}
                      >
                        <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                          {(info?.shuck_info?.cleft_fruit_low_pic || []).length ? '' : <><Button icon={<UploadOutlined />}>上传图片</Button></>}
                        </div>
                      </Upload>
                    </Form.Item>
                  </Col>
                </Row>
                <Index list={info?.shuck_info?.cleft_fruit_low_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'cleft_fruit_low_pic', 'shuck_info')} />
                <Row>
                  <Col span={10}>
                    <Form.Item size='small' colon={false} label="开裂长度30%-50%" wrapperCol={{ span: 12 }}>
                      <div style={{ display: 'flex', 'alignItems': 'center' }}>
                        <Form.Item size='small' name="cleft_fruit_middle" noStyle >
                          <InputNumber disabled={!canEdit} controls={false} min={0} precision={0} />
                        </Form.Item>
                        <span>个</span>
                      </div>
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item size='small' colon={false} label="占比" >
                      <div style={{ display: 'flex', 'alignItems': 'center' }}>
                        <Form.Item size='small' name="cleft_fruit_middle_percent" noStyle >
                          <Input disabled defaultValue={computed_cleft_fruit_middle_percent()} />
                        </Form.Item>
                        <span>%</span>
                      </div>
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item size='small' name="cleft_fruit_middle_pic" rules={[{ required: cleft_fruit_middle_required, message: '请上传问题果图片!', },]}>
                      <Upload
                        name="file"
                        headers={{ token: localStorage.getItem('token') }}
                        showUploadList={false}
                        customRequest={(file) => pic_change(file, 'cleft_fruit_middle_pic', 'shuck_info')}
                        accept="image/png, image/jpeg"
                        fileList={(info?.shuck_info?.cleft_fruit_middle_pic || [])}
                        disabled={!canEdit}
                      >
                        <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                          {(info?.shuck_info?.cleft_fruit_middle_pic || []).length ? '' : <><Button icon={<UploadOutlined />}>上传图片</Button></>}
                        </div>
                      </Upload>
                    </Form.Item>
                  </Col>
                </Row>
                <Index list={info?.shuck_info?.cleft_fruit_middle_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'cleft_fruit_middle_pic', 'shuck_info')} />
                <Row>
                  <Col span={10}>
                    <Form.Item size='small' colon={false} label="开裂长度大于50%" wrapperCol={{ span: 12 }}>
                      <div style={{ display: 'flex', 'alignItems': 'center' }}>
                        <Form.Item size='small' name="cleft_fruit_high" noStyle >
                          <InputNumber disabled={!canEdit} controls={false} min={0} precision={0} />
                        </Form.Item>
                        <span>个</span>
                      </div>
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item size='small' colon={false} label="占比" >
                      <div style={{ display: 'flex', 'alignItems': 'center' }}>
                        <Form.Item size='small' name="cleft_fruit_high_percent" noStyle >
                          <Input disabled defaultValue={computed_cleft_fruit_high_percent()} />
                        </Form.Item>
                        <span>%</span>
                      </div>
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item size='small' name="cleft_fruit_high_pic" rules={[{ required: cleft_fruit_high_required, message: '请上传问题果图片!', },]}>
                      <Upload
                        name="file"
                        headers={{ token: localStorage.getItem('token') }}
                        showUploadList={false}
                        customRequest={(file) => pic_change(file, 'cleft_fruit_high_pic', 'shuck_info')}
                        accept="image/png, image/jpeg"
                        fileList={(info?.shuck_info?.cleft_fruit_high_pic || [])}
                        disabled={!canEdit}
                      >
                        <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                          {(info?.shuck_info?.cleft_fruit_high_pic || []).length ? '' : <><Button icon={<UploadOutlined />}>上传图片</Button></>}
                        </div>
                      </Upload>
                    </Form.Item>
                  </Col>
                </Row>
                <Index list={info?.shuck_info?.cleft_fruit_high_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'cleft_fruit_high_pic', 'shuck_info')} />
                <Row>
                  <Col span={9}>
                    <Form.Item size='small' colon={false} label="总计" wrapperCol={{ span: 12 }}>
                      <div style={{ display: 'flex', 'alignItems': 'center' }}>
                        <Form.Item size='small' name="cleft_fruit_number" noStyle>
                          <InputNumber disabled={!canEdit} controls={false} precision={0} min={0} defaultValue={computed_cleft_fruit_number()} />
                        </Form.Item>
                        <span>个</span>
                      </div>
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item size='small' colon={false} label="占比" >
                      <div style={{ display: 'flex', 'alignItems': 'center' }}>
                        <Form.Item size='small' name="cleft_fruit_number_percent" noStyle >
                          <Input disabled defaultValue={computed_cleft_fruit_number_percent()} />
                        </Form.Item>
                        <span>%</span>
                      </div>
                    </Form.Item>
                  </Col>
                </Row>
              </div>
              {/* <Row>
                <Col span={9}>
                  <Form.Item size='small' colon={false} label="裂口" wrapperCol={{ span: 12 }}>
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="cleft_fruit" noStyle >
                        <InputNumber disabled={!canEdit} controls={false} min={0} precision={0} />
                      </Form.Item>
                      <span>个</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item size='small' colon={false} label="占比">
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="cleft_fruit_percent" defaultValue={computed_cleft_fruit_percent()} noStyle >
                        <Input disabled />
                      </Form.Item>
                      <span>%</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col offset={1} span={10}>
                  <Form.Item size='small' name="cleft_fruit_pic" rules={[{ required: cleft_fruit_required, message: '请上传问题果图片!', },]}>
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      customRequest={(file) => cleft_fruit_pic_change(file)}
                      accept="image/png, image/jpeg"
                      fileList={(info?.shuck_info?.cleft_fruit_pic || [])}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {(info?.shuck_info?.cleft_fruit_pic || []).length ? '' : <><Button icon={<UploadOutlined />}>上传图片</Button><span className='upload-span'>请将问题果放在一起拍照</span></>}
                      </div>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
              <Index list={info?.shuck_info?.cleft_fruit_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={cleft_fruit_pic_remove} /> */}

              {/* <Row>
                <Col span={24}>
                  <Form.Item size='small' name="maturity" colon={false} label="成熟度" labelCol={6} wrapperCol={18} rules={[{ required: true, message: '请选择成熟度!', },]}>
                    <Checkbox.Group disabled={!canEdit}>
                      {(maturityList || []).map(item => <Checkbox key={item.name} value={item.name} style={{ lineHeight: '32px', }}>{item.name}</Checkbox>)}
                    </Checkbox.Group>
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <Form.Item size='small' name="shuck_info_describe" colon={false} label='描述' labelCol={6}>
                    <Input disabled={!canEdit} maxLength={100} />
                  </Form.Item>
                </Col>
              </Row> */}
              <div className='quality-report-title'>内部问题</div>
              <Row>
                <Col span={4}>
                  <Form.Item size='small' colon={false} name="fruit_shell_in_type">
                    <Radio.Group vertical >
                      <Radio value='正常'>正常</Radio>
                      <Radio value='有异常'>有异常</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={3}>
                  <Form.Item size='small' colon={false} label="生果" >
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="bear_fruit" noStyle  >
                        <InputNumber disabled={!canEdit} controls={false} min={0} precision={0} />
                      </Form.Item>
                      <span>个</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item size='small' colon={false} label="占比">
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="bear_fruit_percent" defaultValue={computed_bear_fruit_percent()} noStyle >
                        <Input disabled />
                      </Form.Item>
                      <span>%</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={3}>
                  <Form.Item size='small' name="bear_fruit_pic" rules={[{ required: bear_fruit_required, message: '请上传问题果图片!' }]}>
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      customRequest={(file) => pic_change(file, 'bear_fruit_pic', 'shuck_info')}
                      accept="image/png, image/jpeg"
                      fileList={(info?.shuck_info?.bear_fruit_pic || [])}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {(info?.shuck_info?.bear_fruit_pic || []).length ? '' : <><Button icon={<UploadOutlined />}>上传图片</Button></>}
                      </div>
                    </Upload>
                  </Form.Item>
                  <Index list={info?.shuck_info?.bear_fruit_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'bear_fruit_image', 'shuck_info')} />
                </Col>
                <Col span={12}>
                  <Form.Item size='small' name="bear_fruit_video" rules={[{ required: bear_fruit_required, message: '请上传问题果图片!', },]} wrapperCol={{ span: 24 }}>
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      customRequest={(file) => pic_change(file, 'bear_fruit_video', 'shuck_info')}
                      accept=".mp4"
                      fileList={(info?.shuck_info?.bear_fruit_video || [])}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {(info?.shuck_info?.bear_fruit_video || []).length ? '' : <><Button icon={<UploadOutlined />}>上传视频</Button>
                          <span className='upload-span'>附上仓库中榴莲储存的图片以及展示温度测量和果肉检查的视频</span></>}
                      </div>
                    </Upload>
                  </Form.Item>
                  <Index list={info?.shuck_info?.bear_fruit_video || []} type='video' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'bear_fruit_video', 'shuck_info')} />
                </Col>
              </Row>
              <Row>
                <Col span={3}>
                  <Form.Item size='small' colon={false} label="死包" >
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="dead_fruit" noStyle  >
                        <InputNumber disabled={!canEdit} controls={false} min={0} precision={0} />
                      </Form.Item>
                      <span>个</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item size='small' colon={false} label="占比">
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="dead_fruit_percent" defaultValue={computed_dead_fruit_percent()} noStyle >
                        <Input disabled />
                      </Form.Item>
                      <span>%</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={3}>
                  <Form.Item size='small' name="dead_fruit_pic" rules={[{ required: dead_fruit_required, message: '请上传问题果图片!', },]}>
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      customRequest={(file) => pic_change(file, 'dead_fruit_pic', 'shuck_info')}
                      accept="image/png, image/jpeg"
                      fileList={(info?.shuck_info?.dead_fruit_pic || [])}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {(info?.shuck_info?.dead_fruit_pic || []).length ? '' : <><Button icon={<UploadOutlined />}>上传图片</Button></>}
                      </div>
                    </Upload>
                  </Form.Item>
                  <Index list={info?.shuck_info?.dead_fruit_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'dead_fruit_pic', 'shuck_info')} />
                </Col>
                <Col span={12}>
                  <Form.Item size='small' name="dead_fruit_video" rules={[{ required: dead_fruit_required, message: '请上传问题果图片!', },]} wrapperCol={{ span: 24 }}>
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      customRequest={(file) => pic_change(file, 'dead_fruit_video', 'shuck_info')}
                      accept=".mp4"
                      fileList={(info?.shuck_info?.dead_fruit_video || [])}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {(info?.shuck_info?.dead_fruit_video || []).length ? '' : <><Button icon={<UploadOutlined />}>上传视频</Button>
                          <span className='upload-span'>附上仓库中榴莲储存的图片以及展示温度测量和果肉检查的视频</span></>}
                      </div>
                    </Upload>
                  </Form.Item>
                  <Index list={info?.shuck_info?.dead_fruit_video || []} type='video' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'dead_fruit_video', 'shuck_info')} />
                </Col>
              </Row>
              <div className='quality-report-title'>果肉</div>
              <Row>
                <Col span={4}>
                  <Form.Item size='small' colon={false} name="fruit_flesh_type">
                    <Radio.Group vertical >
                      <Radio value='正常'>正常</Radio>
                      <Radio value='有缺陷'>有缺陷</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={6}>
                  <Form.Item size='small' colon={false} label="腐烂" >
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="fruit_flesh_rot" noStyle >
                        <InputNumber disabled={!canEdit} controls={false} min={0} precision={0} />
                      </Form.Item>
                      <span>个</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item size='small' colon={false} label="占比" >
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="fruit_flesh_rot_percent" noStyle >
                        <Input disabled defaultValue={computed_fruit_flesh_rot_percent()} />
                      </Form.Item>
                      <span>%</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item size='small' name="fruit_flesh_rot_pic" rules={[{ required: fruit_flesh_rot_required, message: '请上传问题果图片!', },]}>
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      customRequest={(file) => pic_change(file, 'fruit_flesh_rot_pic', 'shuck_info')}
                      accept="image/png, image/jpeg"
                      fileList={(info?.shuck_info?.fruit_flesh_rot_pic || [])}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {(info?.shuck_info?.fruit_flesh_rot_pic || []).length ? '' : <><Button icon={<UploadOutlined />}>上传图片</Button></>}
                      </div>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
              <Index list={info?.shuck_info?.fruit_flesh_rot_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'fruit_flesh_rot_pic', 'shuck_info')} />
              <Row>
                <Col span={6}>
                  <Form.Item size='small' colon={false} label="疫病菌" >
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="fruit_flesh_blight" noStyle >
                        <InputNumber disabled={!canEdit} controls={false} min={0} precision={0} />
                      </Form.Item>
                      <span>个</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item size='small' colon={false} label="占比" >
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="fruit_flesh_blight_percent" noStyle >
                        <Input disabled defaultValue={computed_fruit_flesh_blight_percent()} />
                      </Form.Item>
                      <span>%</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item size='small' name="fruit_flesh_blight_pic" rules={[{ required: fruit_flesh_blight_required, message: '请上传问题果图片!', },]}>
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      customRequest={(file) => pic_change(file, 'fruit_flesh_blight_pic', 'shuck_info')}
                      accept="image/png, image/jpeg"
                      fileList={(info?.shuck_info?.fruit_flesh_blight_pic || [])}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {(info?.shuck_info?.fruit_flesh_blight_pic || []).length ? '' : <><Button icon={<UploadOutlined />}>上传图片</Button></>}
                      </div>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
              <Index list={info?.shuck_info?.fruit_flesh_blight_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'fruit_flesh_blight_pic', 'shuck_info')} />
              <Row>
                <Col span={6}>
                  <Form.Item size='small' colon={false} label="虫果" >
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="fruit_flesh_wormy" noStyle >
                        <InputNumber disabled={!canEdit} controls={false} min={0} precision={0} />
                      </Form.Item>
                      <span>个</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item size='small' colon={false} label="占比" >
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="fruit_flesh_wormy_percent" noStyle >
                        <Input disabled defaultValue={computed_fruit_flesh_wormy_percent()} />
                      </Form.Item>
                      <span>%</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item size='small' name="fruit_flesh_wormy_pic" rules={[{ required: fruit_flesh_wormy_required, message: '请上传问题果图片!', },]}>
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      customRequest={(file) => pic_change(file, 'fruit_flesh_wormy_pic', 'shuck_info')}
                      accept="image/png, image/jpeg"
                      fileList={(info?.shuck_info?.fruit_flesh_wormy_pic || [])}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {(info?.shuck_info?.fruit_flesh_wormy_pic || []).length ? '' : <><Button icon={<UploadOutlined />}>上传图片</Button></>}
                      </div>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
              <Index list={info?.shuck_info?.fruit_flesh_wormy_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'fruit_flesh_wormy_pic', 'shuck_info')} />
              <Row>
                <Col span={6}>
                  <Form.Item size='small' colon={false} label="烧核" >
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="fruit_flesh_burning" noStyle >
                        <InputNumber disabled={!canEdit} controls={false} min={0} precision={0} />
                      </Form.Item>
                      <span>个</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item size='small' colon={false} label="占比" >
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="fruit_flesh_burning_percent" noStyle >
                        <Input disabled defaultValue={computed_fruit_flesh_burning_percent()} />
                      </Form.Item>
                      <span>%</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item size='small' name="fruit_flesh_burning_pic" rules={[{ required: fruit_flesh_burning_required, message: '请上传问题果图片!', },]}>
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      customRequest={(file) => pic_change(file, 'fruit_flesh_burning_pic', 'shuck_info')}
                      accept="image/png, image/jpeg"
                      fileList={(info?.shuck_info?.fruit_flesh_burning_pic || [])}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {(info?.shuck_info?.fruit_flesh_burning_pic || []).length ? '' : <><Button icon={<UploadOutlined />}>上传图片</Button></>}
                      </div>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
              <Index list={info?.shuck_info?.fruit_flesh_burning_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'fruit_flesh_burning_pic', 'shuck_info')} />
              <Row>
                <Col span={6}>
                  <Form.Item ize='small' colon={false} label="总计" >
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="fruit_flesh_number" noStyle>
                        <InputNumber disabled={!canEdit} controls={false} precision={0} min={0} defaultValue={computed_fruit_flesh_number()} />
                      </Form.Item>
                      <span>个</span>
                    </div>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item size='small' colon={false} label="占比" >
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="fruit_flesh_number_percent" noStyle >
                        <Input disabled defaultValue={computed_fruit_flesh_number_percent()} />
                      </Form.Item>
                      <span>%</span>
                    </div>
                  </Form.Item>
                </Col>
              </Row>

              {/* <Row>
                <Col span={10}>
                  <Form.Item size='small' colon={false} label="果肉硬度" name="hardness_flesh" rules={[{ required: true, message: '请选择果肉硬度!', },]}>
                    <Select disabled={!canEdit}>{(hardnessFleshList || []).map(item => <Option key={item.name} value={item.name}>{item.name}</Option>)}</Select>
                  </Form.Item>
                </Col>
                <Col span={14}>
                  <Form.Item size='small' name="hardness_flesh_video" colon={false} labelCol={{ span: 3 }} rules={[{ required: true, message: '请上传1个果肉硬度视频，限制格式：MP4，时长不超过60s!', },]}>
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      listType='text'
                      beforeUpload={hardness_flesh_video_before_upload}
                      fileList={(info?.flesh_info?.hardness_flesh_video || [])}
                      customRequest={(file) => hardness_flesh_video_change(file)}
                      accept=".mp4"
                      maxCount={1}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {(info?.flesh_info?.hardness_flesh_video || []).length ? '' : <><Button icon={<UploadOutlined />}>上传视频</Button></>}
                      </div>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
              <Index list={info?.flesh_info?.hardness_flesh_video || []} type='video' preview={showModal} edit={canEdit} closeEvent={hardness_flesh_video_remove} /> */}
              <div className='quality-report-title'>糖度</div>
              <Row>
                <Col span={8}>
                  <Form.Item size='small' colon={false} label="糖度检测抽样" required>
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="sugar_sampling_type" noStyle rules={[{ required: true, message: '请选择糖度检测抽样!', },]}>
                        <Select disabled={!canEdit}>
                          <Option value={1}>1</Option>
                          <Option value={2}>2</Option>
                          <Option value={3}>3</Option>
                        </Select>
                      </Form.Item>
                      <span>个</span>
                    </div>
                  </Form.Item>
                </Col>
              </Row>
              {
                sugar_sampling_computed >= 1 && (
                  <Row>
                    <Col span={7}>
                      <Form.Item size='small' colon={false} label="糖度1" required>
                        <div style={{ display: 'flex', 'alignItems': 'center' }}>
                          <Form.Item size='small' name="sugar_sampling1" noStyle rules={[{ required: true, message: '请填写糖度1!', },]}>
                            <InputNumber disabled={!canEdit} controls={false} min={0} precision={1} />
                          </Form.Item>
                          <span>%Brix</span>
                        </div>
                      </Form.Item>
                    </Col>
                    <Col span={7}>
                      <Form.Item size='small' name="sugar_sampling1_pic" label='' rules={[{ required: true, message: '请上传糖度1图片!', },]}>
                        <Upload
                          name="file"
                          headers={{ token: localStorage.getItem('token') }}
                          showUploadList={false}
                          customRequest={(file) => pic_change(file, 'sugar_sampling1_pic', 'flesh_info')}
                          accept="image/png, image/jpeg"
                          fileList={(info?.flesh_info?.sugar_sampling1_pic || [])}
                          disabled={!canEdit}
                        >
                          <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                            {(info?.flesh_info?.sugar_sampling1_pic || []).length ? '' : <><Button icon={<UploadOutlined />}>上传图片</Button></>}
                          </div>
                        </Upload>
                      </Form.Item>
                    </Col>
                  </Row>
                )}
              <Index list={info?.flesh_info?.sugar_sampling1_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'sugar_sampling1_pic', 'flesh_info')} />
              {sugar_sampling_computed >= 2 && (
                <Row>
                  <Col span={7}>
                    <Form.Item size='small' colon={false} label="糖度2" required>
                      <div style={{ display: 'flex', 'alignItems': 'center' }}>
                        <Form.Item size='small' name="sugar_sampling2" noStyle rules={[{ required: true, message: '请填写糖度2!', },]}>
                          <InputNumber disabled={!canEdit} controls={false} min={0} precision={1} />
                        </Form.Item>
                        <span>%Brix</span>
                      </div>
                    </Form.Item>
                  </Col>
                  <Col span={7}>
                    <Form.Item size='small' name="sugar_sampling2_pic" label='' rules={[{ required: true, message: '请上传糖度2图片!', },]}>
                      <Upload
                        name="file"
                        headers={{ token: localStorage.getItem('token') }}
                        showUploadList={false}
                        customRequest={(file) => pic_change(file, 'sugar_sampling2_pic', 'flesh_info')}
                        accept="image/png, image/jpeg"
                        fileList={(info?.flesh_info?.sugar_sampling2_pic || [])}
                        disabled={!canEdit}
                      >
                        <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                          {(info?.flesh_info?.sugar_sampling2_pic || []).length ? '' : <><Button icon={<UploadOutlined />}>上传图片</Button></>}
                        </div>
                      </Upload>
                    </Form.Item>
                  </Col>
                </Row>
              )}
              <Index list={info?.flesh_info?.sugar_sampling2_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'sugar_sampling2_pic', 'flesh_info')} />
              {sugar_sampling_computed >= 3 && (
                <Row>
                  <Col span={7}>
                    <Form.Item size='small' colon={false} label="糖度3" required rules={[{ required: true, message: '请填写糖度3!', },]}>
                      <div style={{ display: 'flex', 'alignItems': 'center' }}>
                        <Form.Item size='small' name="sugar_sampling3" noStyle rules={[{ required: true, message: '请填写糖度3!', },]}>
                          <InputNumber disabled={!canEdit} controls={false} min={0} precision={1} />
                        </Form.Item>
                        <span>%Brix</span>
                      </div>
                    </Form.Item>
                  </Col>
                  <Col span={7}>
                    <Form.Item size='small' name="sugar_sampling3_pic" label='' rules={[{ required: true, message: '请上传糖度3图片!', },]}>
                      <Upload
                        name="file"
                        headers={{ token: localStorage.getItem('token') }}
                        showUploadList={false}
                        customRequest={(file) => pic_change(file, 'sugar_sampling3_pic', 'flesh_info')}
                        accept="image/png, image/jpeg"
                        fileList={(info?.flesh_info?.sugar_sampling3_pic || [])}
                        disabled={!canEdit}
                      >
                        <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                          {(info?.flesh_info?.sugar_sampling3_pic || []).length ? '' : <><Button icon={<UploadOutlined />}>上传图片</Button></>}
                        </div>
                      </Upload>
                    </Form.Item>
                  </Col>
                </Row>
              )}
              <Index list={info?.flesh_info?.sugar_sampling3_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'sugar_sampling3_pic', 'flesh_info')} />
              <Row>
                <Col span={7}>
                  <Form.Item size='small' colon={false} label="平均糖度" required>
                    <div style={{ display: 'flex', 'alignItems': 'center' }}>
                      <Form.Item size='small' name="average_sugar" noStyle rules={[{ required: true, message: '请填写平均糖度!', },]}>
                        <InputNumber disabled={!canEdit} controls={false} min={0} precision={1} defaultValue={computed_average_sugar()} />
                      </Form.Item>
                      <span>%Brix</span>
                    </div>
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={6}>
                  <Form.Item size='small' colon={false} label="果肉颜色" name="flesh_color" rules={[{ required: true, message: '请选择果肉颜色!', },]}>
                    <Select disabled={!canEdit}>{(fleshColorList || []).map(item => <Option key={item.name} value={item.name}>{item.name}</Option>)}</Select>
                  </Form.Item>
                </Col>
                <Col span={7}>
                  <Form.Item size='small' name="flesh_color_pic" label='' rules={[{ required: true, message: '请上传果肉颜色图片!', },]}>
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      customRequest={(file) => pic_change(file, 'flesh_color_pic', 'flesh_info')}
                      accept="image/png, image/jpeg"
                      fileList={(info?.flesh_info?.flesh_color_pic || [])}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {(info?.flesh_info?.flesh_color_pic || []).length ? '' : <><Button icon={<UploadOutlined />}>上传图片</Button></>}
                      </div>
                    </Upload>
                  </Form.Item>
                </Col>
                <Col span={7}>
                  <Form.Item size='small' colon={false} label="口感" name="flesh_taste" rules={[{ required: true, message: '请选择口感!', },]}>
                    <Select disabled={!canEdit}>{(fleshTasteList || []).map(item => <Option key={item.name} value={item.name}>{item.name}</Option>)}</Select>
                  </Form.Item>
                </Col>
              </Row>
              <Index list={info?.flesh_info?.flesh_color_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'flesh_color_pic', 'flesh_info')} />
              <div className='quality-report-title'>其他记录</div>
              <Row>
                <Col span={6}>
                  <Form.Item size='small' name="inspection_scene_pic" colon={false} label='质检现场' rules={[{ required: true, message: '请上传' }]}>
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      listType='text'
                      fileList={(info?.other_info?.inspection_scene_pic || [])}
                      customRequest={(file) => inspection_scene_change(file)}
                      accept="image/png, image/jpeg"
                      maxCount={1}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {(info?.other_info?.inspection_scene_pic || []).length < 3 && <><Button icon={<UploadOutlined />}>上传图片</Button></>}
                      </div>
                    </Upload>
                  </Form.Item>
                  <Index list={info?.other_info?.inspection_scene_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => inspection_scene_remove(e)} />
                </Col>
                <Col span={18}>
                  <Form.Item size='small' name="inspection_scene_video" colon={false} wrapperCol={{ span: 24 }} label='' rules={[{ required: true, message: '请上传' }]}>
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      listType='text'
                      beforeUpload={inspection_video_before_upload}
                      fileList={(info?.other_info?.inspection_scene_video || [])}
                      customRequest={(file) => inspection_video_change(file)}
                      accept=".mp4"
                      maxCount={1}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {(info?.other_info?.inspection_scene_video || []).length ? '' : <><Button icon={<UploadOutlined />}>上传视频</Button></>}
                      </div>
                      <span className='upload-span'>包含质检环境、仓库温度和风机的图片和视频，视频限制格式：MP4，时长不超过60s</span>
                    </Upload>
                  </Form.Item>
                  <Index list={info?.other_info?.inspection_scene_video || []} type='video' preview={showModal} edit={canEdit} closeEvent={inspection_video_remove} />
                </Col>
              </Row>
              <Row>
                <Col span={6}>
                  <Form.Item size='small' name="inspection_process_pic" colon={false} label='质检过程' rules={[{ required: true, message: '请上传' }]}>
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      listType='text'
                      fileList={(info?.other_info?.inspection_process_pic || [])}
                      customRequest={(file) => inspection_process_change(file)}
                      accept="image/png, image/jpeg"
                      maxCount={1}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {(info?.other_info?.inspection_process_pic || []).length < 3 && <><Button icon={<UploadOutlined />}>上传图片</Button></>}
                      </div>
                    </Upload>
                  </Form.Item>
                  <Index list={info?.other_info?.inspection_process_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => inspection_process_remove(e)} />
                </Col>
                <Col span={18}>
                  <Form.Item size='small' name="inspection_process_video" colon={false} wrapperCol={{ span: 24 }} label='' rules={[{ required: true, message: '请上传' }]}>
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      listType='text'
                      beforeUpload={inspection_video_before_upload}
                      fileList={(info?.other_info?.inspection_process_video || [])}
                      customRequest={(file) => pic_change(file, 'inspection_process_video', 'other_info')}
                      accept=".mp4"
                      maxCount={1}
                      disabled={!canEdit}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {(info?.other_info?.inspection_process_video || []).length ? '' : <><Button icon={<UploadOutlined />}>上传视频</Button></>}
                      </div>
                      <span className='upload-span'>质检过程照片和视频，视频限制格式：MP4，时长不超过60s</span>
                    </Upload>
                  </Form.Item>
                  <Index list={info?.other_info?.inspection_process_video || []} type='video' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'inspection_process_video', 'other_info')} />
                </Col>
              </Row>
              <Row>
                <Col span={6}>
                  <Form.Item size='small' name="inspection_pic" colon={false} label='质检卡' rules={[{ required: true, message: '请上传1-3张图片，质检卡注意事项：1.信息准确、字迹清晰；2.签收人签字；3.财务人员签字!', },]}>
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      listType='text'
                      fileList={(info?.other_info?.inspection_pic || [])}
                      customRequest={(file) => inspection_pic_change(file)}
                      accept="image/png, image/jpeg"
                      maxCount={3}
                      disabled={!canEdit}
                      multiple
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {((info?.other_info?.inspection_pic || []).length < 3) && <><Button icon={<UploadOutlined />}>上传图片</Button></>}
                      </div>
                    </Upload>
                  </Form.Item>
                  <Index list={info?.other_info?.inspection_pic || []} type='image' preview={showModal} edit={canEdit} closeEvent={(e) => inspection_pic_remove(e)} />
                </Col>
                <Col span={18}>
                  <Form.Item size='small' name="inspection_card_video" colon={false} wrapperCol={{ span: 24 }} label='' rules={[{ required: true, message: '请上传' }]}>
                    <Upload
                      name="file"
                      headers={{ token: localStorage.getItem('token') }}
                      showUploadList={false}
                      listType='text'
                      fileList={(info?.other_info?.inspection_card_video || [])}
                      customRequest={(file) => pic_change(file, 'inspection_card_video', 'other_info')}
                      accept=".mp4"
                      maxCount={3}
                      disabled={!canEdit}
                      multiple
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {((info?.other_info?.inspection_card_video || []).length) ? "" : <><Button icon={<UploadOutlined />}>上传视频</Button></>}
                      </div>
                      <span className='upload-span'>质检卡签字（中方）照片和视频，视频限制格式：MP4，时长不超过60s</span>
                    </Upload>
                  </Form.Item>
                  <Index list={info?.other_info?.inspection_card_video || []} type='video' preview={showModal} edit={canEdit} closeEvent={(e) => public_carton_remove(e, 'inspection_card_video', 'other_info')} />
                </Col>
              </Row>
              {/* <Row>
                <Col span={24}>
                  <Form.Item size='small' name="inspection_report" colon={false} label='质检报告附件' labelCol={{ span: 3 }} rules={[{ required: false, message: '请上传质检报告附件!', },]}>
                    <Upload
                      style={{ visibility: !canEdit ? 'hidden' : '' }}
                      name="file"
                      // showUploadList={false}
                      listType='text'
                      beforeUpload={inspection_report_upload}
                      fileList={(info?.other_info?.inspection_report || [])}
                      customRequest={(file) => inspection_report_change(file)}
                      onRemove={file => inspection_report_remove(file)}
                      accept=".pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.jpg,.png"
                      maxCount={1}
                      disabled={!canEdit}
                      showUploadList={{
                        showRemoveIcon: canEdit,
                        showDownloadIcon: !canEdit
                      }}
                    >
                      <div style={{ visibility: !canEdit ? 'hidden' : '' }}>
                        {(info?.other_info?.inspection_report || []).length ? '' : <><Button icon={<UploadOutlined />}>上传文件</Button>
                          <span className='upload-span'>文件限制格式：pdf、doc、docx、ppt、pptx、xls、xlsx、jpg、png，20M内</span></>}
                      </div>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row> */}

              <div className='quality-report-title'>买方意见</div>
              <Row>
                <Col span={24}>
                  <Form.Item size='small' name="buy_comments" wrapperCol={{ span: 24 }}>
                    <TextArea disabled={!canEdit} maxLength={400} placeholder={canEdit ? '请对整柜质检结果进行评价，并给出意见' : ''} />
                  </Form.Item>
                </Col>
              </Row >
              {
                canEdit ? <div className='quality-report-fixed'>
                  <div className='quality-report-fixed-content'>
                    <Form.Item><Button className='quality-report-fixed-content-btn' type="primary" htmlType="submit">提交</Button></Form.Item>
                    <Form.Item><Button className='quality-report-fixed-content-btn' type="primary" onClick={draft}>保存草稿</Button></Form.Item>
                    <Button className='quality-report-fixed-content-btn' type="primary" onClick={cancel}>返回</Button>
                  </div>
                </div> : null
              }
            </Form>
            {
              (String(info?.status) === '3') ? <>
                <div className='quality-report-title'>卖方处理意见</div>
                {+info?.handling_opinions === 0 && info?.sale_comments.trim() === '' ? <div>-</div> :
                  <>
                    <div>{handling_opinion[+info?.handling_opinions]}</div>
                    <div style={{ whiteSpace: 'pre-wrap' }} >{info?.sale_comments}</div>
                  </>
                }
              </> : null
            }
          </div>
        </> : <Spin tip="Loading..."></Spin>
      }
      {
        modalVisible && <Modal open={true} onOk={handleOk} onCancel={handleCancel} footer={null} centered>
          <div className='port-quality-report-modal-content'>
            {(currentOptions?.type === 'image') && <img className='port-quality-report-modal-camera' src={currentOptions?.item} alt='' />}
            {(currentOptions?.type === 'video') && <video className='port-quality-report-modal-camera' controls controlsList="nofullscreen nodownload noremoteplayback" disablePictureInPicture><source src={currentOptions?.item} /></video>}
          </div>
        </Modal>
      }
    </div>
  );
}
